export default {
  pledgeLoanPendingReview: "심사 대기",
  pledgeLoanOverdue: "기한 초과",
  pledgeLoanName: "담보 대출",
  pledgeLoanInterest: "이자",
  pledgeLoanMaturityDate: "만기 날짜",
  pledgeLoanHeroTitle: "디지털 자산을 최대한 활용하여 더 큰 수익을 얻으세요!",
  pledgeLoanCurrency: "통화",
  pledgeLoanApplicationDate: "신청 날짜",
  pledgeLoanCollateralTerm: "담보 기간",
  pledgeLoanHeroSubtitle: "프로모션 기간 동안 담보 이자는 0입니다.",
  pledgeLoanRejected: "거절됨",
  pledgeLoanBorrowAmount: "차입 금액",
  pledgeLoanReviewDate: "심사 날짜",
  pledgeLoanWithdrawalWarning: "미정산 담보 대출 주문이 있습니다. 출금 신청 전 정산을 완료해 주세요.",
  pledgeLoanRepayment: "상환",
  pledgeLoanUnpayAmount: "미상환 금액",
  pledgeLoanRepayTime: "정산 시간",
  pledgeLoanCollateralAmount: "담보 금액",
  pledgeLoanCollateralRatio: "담보 비율",
  pledgeLoanInProgress: "진행 중",
  pledgeLoanSettled: "정산 완료",
  pledgeLoanApplyNow: "지금 신청",
  pledgeLoanFinishedText: "더 이상 데이터가 없습니다",
  pledgeLoanPreviewOnly: "미리보기 전용입니다. 신청서는 제출되지 않았습니다.",
  required: '필수의',
  home: '시작',
  market: '시장',
  currency: '교환',
  walletTrade: '자금 계좌',
  contract: '계약',
  wallet: '자산',
  pulling: '새로고침하려면 아래로 당기세요...',
  loosing: '새로고침하려면 손을 뗍니다...',
  loading: '로드 중...',
  loadingError: '불러 오지 못했습니다',
  nothing: '데이터 없음',
  finished: '',
  price: '가격',
  number: '수량',
  recharge: '보증금',
  transfer: '옮기다',
  invite: '초대',
  inviteDes: '친구 초대하기',
  contact: '문의하기',
  contactDes: '7*24 온라인',
  fastTrade: '옵션',
  name: '이름',
  fastPrice: '가격',
  trend: '24H %',
  all: '모두',
  growthList: '승자',
  loserList: '패자',
  vol: '24H Vol',
  buy: '구입',
  sell: '팔다',
  optimal: '시장 가격',
  marketOrder: '시장 무역',
  limitOrder: '거래 제한',
  useable: '사용 가능',
  tradeVol: '양',
  entrust: '지정가 주문',
  entrustTotal: '양',
  noLogin: '로그 아웃, ',
  toLogin: '지금 로그인하십시오',
  cancelOrder: '취소',
  cancelError: '취소하지 못했습니다.',
  cancelSuccess: '성공적으로 취소',
  cancelTip: '취소하시겠습니까?',
  completed: '완전한',
  canceled: '취소 된',
  marketPrice: '시장',
  limitPrice: '한계',
  entrustPrice: '가격',
  entrustNum: '수량',
  currencyType: '상징',
  headerCurrencyType: '상징',
  currencyOrder: '무역 기록',
  history: '역사',
  tryAgain: '다시 시도하십시오',
  entrustPriceTip: '입력 가격',
  tradeNumTip: '입력 수량',
  tradeNumLess: '수량은 0보다 커야 합니다.',
  numLessTip: '잔액 불충분',
  tradePriceTip: '투입금액',
  balanceTip: '잔액 불충분',
  tradeError: '거래에 실패했습니다',
  tradeSuccess: '성공적으로 거래',
  tip: '알아채다',
  tradeConfirm: '거래를 확인하시겠습니까?',
  cancelText: '취소',
  confirmText: '확인하다',
  toBuy: '사다',
  toSell: '공매도',
  confirmToBuy: '사다',
  confirmToSell: '공매도',
  slPrice: 'SL 가격',
  sl: 'SL',
  tp: 'TP',
  tpPrice: 'TP 가격',
  currentOrder: '현재 주문',
  historyOrder: '역사',
  setting: '세트',
  unwind: '닫다',
  handUnwind: '수동으로 닫기',
  futuresPay: '',
  forceUnwind: '변제',
  slTp: 'SL/TP',
  fastTradeUnwind: '옵션',
  blowUp: '변제',
  openNum: '수량',
  warrant: '여유',
  openPrice: '가격',
  fee: '요금',
  profit: '이익',
  lastPrice: '현재 가격',
  unwindPrice: '종가',
  unwindError: '닫기 실패',
  unwindSuccess: '성공적으로 종료',
  setSuccess: '성공적으로 설정',
  setError: '설정 실패',
  setSlTp: '세트 SL/TP',
  second: 's',
  multiple: '다수의',
  direction: '유형',
  tradeCurrency: '상징',
  loss: '상실',
  fill: '이기다',
  executePrice: '가격',
  currentPrice: '현재 가격',
  closePrice: '종가',
  secondNum: '기간',
  contractOrder: '선물 주문',
  fastTradeOrder: '옵션 주문',
  overview: '자산 개요', 
  ieoBuy: '사전 판매',
  ieoBuy1: '사전 판매',
  balanceTotal: '총자산',
  withdraw: '철회하다',
  tradeOrder: '무역 주문',
  rechargeHistory: '입금 기록',
  withdrawHistory: '철회 기록',
  freeze: '겨울 왕국',
  amountTo: '',
  tipText: '알아채다',
  ieoTip: '현재 IEO가 열리지 않았습니다. 나중에 다시 시도하십시오.',
  financeList: '재무 기록',
  currencyAccount: '자금 계좌',
  contractAccount: '선물 계정',
  time: '시간',
  status: '상태',
  balanceTyle: '계정',
  pay: '결과',
  income: '소득',
  lastBalance: '균형',
  orderNo: 'ID',
  money: '양',
  date: '날짜',
  finallyIncome: '받는 금액',
  commitMoney: '양',
  orderNum: 'ID',
  waitReview: '확인 예정',
  reviewPass: '합격',
  reviewReject: '거부됨',
  waitWallet: '검토 중',
  walletPass: '합격',
  walletReject: '거부됨',
  withdrawSuccess: '출금 성공',
  withdrawError: '전송 실패',
  high24H: '24H 높은',
  low24H: '24H 낮은',
  num24H: '24H Vol',
  minute: '분',
  hour: '시간',
  day: '요일',
  week: '주',
  markets: '시장',
  open: '열려 있는',
  close: '닫다',
  high: '높은',
  low: '낮은',
  volume: 'Vol',
  fastLogin: '지금 로그인하십시오',
  register: '등록하다',
  auth: '확인하다',
  authSuccess: '검증됨',
  noPass: '거부됨',
  authCommit: '검토 중',
  onAuth: '미확인',
  onLogin: '로그 아웃',
  securitySet: '보안',
  userAgree: '사용자 지원',
  aboutUs: '회사 소개',
  logout: '로그 아웃',
  logoutSuccess: '성공적으로 로그아웃',
  lookAuthInfo: '내 정보 확인',
  authAgain: '재확인',
  authInfo: '정보',
  account: '계정',
  countryArea: '국가/지역',
  idNo: 'ID#',
  idNoTip: '주민등록번호 입력',
  email: '우편',
  emailInput: '이메일 주소 입력',
  setLoginPwd: '로그인 비밀번호 설정',
  loginPwdInput: '로그인 비밀번호 입력(8~20자)',
  loginPwdTip: '로그인 비밀번호 입력',
  loginPwdLen: '로그인 비밀번호는 8~20자여야 합니다.',
  setFinancePwd: '펀드 비밀번호 설정',
  financePwdInput: '펀드비밀번호 입력(6~20자)',
  financePwdTip: '펀드 비밀번호 입력',
  financePwdLen: '펀드 비밀번호는 6~20자여야 합니다.',
  inviteCode: '초대 코드',
  inviteCodeTip: 'ใส่รหัสคำเชิญ',
  inviteInput: '초대 코드가 필요합니다',
  imageCode: 'Captcha',
  imageCodeInput: '보안문자 입력',
  registerTip: '등록은 동의함을 의미합니다. ',
  agree: '《사용자 계약》',
  agreeText: '사용자 계약',
  next: '다음',
  registerSuccess: '완전히 등록',
  registerError: '등록 실패',
 securityCheck: '보안',
googleAuthenticator: `Google 인증기`,
googleAuthBoundTitle: `이 계정은 Google 인증기가 활성화되어 있습니다.`,
googleAuthBoundDesc: `Google 인증기가 계정을 추가로 보호하고 있습니다.`,
googleAuthEnableTitle: `Google 인증기 활성화`,
googleAuthEnableDesc: `계정에 보안 계층을 추가하세요.`,
googleAuthScanTip: `Google 인증기로 QR 코드를 스캔한 후 6자리 코드를 입력하세요.`,
googleAuthConfirm: `연결 확인`,
googleAuthCodeTitle: `Google 인증`,
googleAuthCodeDesc: `Google 인증기의 6자리 코드를 입력하세요.`,
googleAuthCodeInput: `Google 인증 코드 입력`,
googleAuthBindSuccess: `Google 인증기가 활성화되었습니다`,
googleAuthLoadError: `Google 인증기를 불러오지 못했습니다`,
googleAuthSecret: `비밀 키`,
googleAuthCopySecret: `비밀 키 복사`,
  checkCodeInput: '인증코드 입력',
  sendCheckCode: '보내다',
  sendSuccess: '전송된',
  sendError: '전송 실패',
  welcome: '에 오신 것을 환영합니다',
  loginEmail: '우편',
  loginEmailInput: '이메일 주소 입력',
  loginPwd: '로그인 비밀번호',
  login: '로그인',
  forgetPwd: '비밀번호를 잊으 셨나요',
  loginTip: '로그인은 동의함을 의미합니다.',
  loginSuccess: '완전히 로그인',
  loginError: '로그인 실패',
  fullname: '이름',
  fullnameTip: '이름을 입력하세요',
  country: '국가/지역',
  countryTip: '국가/지역 입력',
  imgFront: '신분증 앞면 사진 업로드',
  imgReverse: '신분증 뒷면 사진 업로드',
  commit: '제출하다',
  commitSuccess: '완전히 제출',
  commitError: '제출 실패',
  selectCurrency: '암호화폐 선택',
  rechargeNet: '회로망',
  rechargeAddress: '입금 주소',
  copyAddress: '주소 복사',
  minRecharge: '최소 입금액',
  copySuccess: '완전히 복사',
  copyError: '복사 실패',
  withdrawTip: '계좌 확인 후 출금 가능',
  withdrawAddress: '출금 주소',
  withdrawAddressInput: '출금 주소 입력',
  withdrawNet: '회로망',
  withdrawNum: '양',
  withdrawNumInput: '투입금액',
  withdrawNumLess: '잔액 불충분',
  withdrawMin: '최소 인출 금액',
  balanceUse: '사용 가능',
  actualMoney: '받는 금액',
  actualMoneyText: '받는 금액',
  financePwd: '자금 비밀번호',
  trade: '',
  withdrawFail: '출금 실패',
  commitTime: '날짜',
  from: '에서',
  to: '에게',
  transferMoney: '투입금액',
  transferSuccess: '완전히 이전',
  transferError: '전송 실패',
  transferHistory: '이적기록',
  updateFinancePwd: '펀드 비밀번호 변경',
  confirmPwd: '비밀번호 확인',
  confirmPwdInput: '비밀번호 확인 입력',
  updatePwd: '비밀번호 변경',
  updatePwdSuccess: '완전히 변경',
  updatePwdError: '변경 실패',
  noAlike: '비밀번호가 일치하지 않습니다',
  emailUpdate: '이메일 주소 변경',
  loginPwdUpdate: '로그인 비밀번호 변경',
  financePwdUpdate: '펀드 비밀번호 변경',
  newEmail: '새로운 이메일 주소',
  emailUpdateTip: '새 이메일 주소 입력',
  checkEmail: '이메일 주소 확인',
  updateEmail: '이메일 주소 변경',
  updateEmailError: '변경 실패',
  updateEmailSuccess: '완전히 변경',
  checkError: '확인 실패',
  pwdLen: '8-20자',
  inviteUrl: '관련 링크',
  myInviteCode: '초대 코드',
  fastInvite: '지금 초대하세요',
  myInvite: '초대 목록',
  registerTime: '날짜',
  bulletin: '발표',
  inviteFriend: '친구를 초대',
  saveAccount: '계정 및 비밀번호 저장',
  indicator: '지표',
  type: '종류',
  amount: '양',
  scanError: '이미지 인식 실패',
  scanInitErr: '초기화 실패',
  noCamera: '카메라 권한 없음',
  secondTip: '금액은 {tip} 이상이어야 합니다.',
  completePrice: '가격',
  profitText: '이익',
  profitAndLoss: '예상 손익',
  timeUp: '시간 최대',
  balanceText: '역사',
  closeAll: '모두 닫기',
  assetRate: '마진율',
  cancel: '취소',
  cancelInfo: '취소하시겠습니까?',
  buyCurrency: '상징',
  closeCurrency: '통화',
  buyPrice: '가격',
  valuation: '평가',
  profitP: '생산하다',
  buySuccess: '성공적으로',
  swiperTitle1: '세계 최고의 디지털 암호화폐 거래소',
  swiperSub1: '100,000명 이상의 사용자가 신뢰하는',
  ieoBuying: '전진',
  ieoOpen: '시작일 (UTC-5)',
  ieoClose: '완료 날짜(UTC-5)',
  about: '에 대한',
  ieoPlan: '분포',
  ieoInfo: '정보',
  ieoContact: '소셜 미디어',
  ieoStart: '초기화',
  ieoBuyStart: 'IEO 시작',
  ieoBuyEnd: 'IEO 마치다',
  ieoIsTrade: '시작하다',
  introduce: '소개',
  ieoSubBuy: 'IEO',
  subBuyHistory: 'IEO 역사',
  rechargeTip1: '1. 이것은 귀하의 최신 고유 주소이며, 플랫폼은 귀하에게 다른 계정으로 자금을 이체하거나 인증 코드를 요청하지 않습니다.',
  rechargeTip2: '2. 보증금은 확인을 위해 최소 10개의 네트워크 블록이 필요합니다. 확인 후 귀하의 계정에 자금이 자동으로 입금됩니다.',
  withdrawTip1: '1. 본 출금은 입금 측과 동일한 네트워크를 선택하고 수신 플랫폼이 네트워크를 지원하는지 확인하십시오. 그렇지 않으면 자산을 잃게 됩니다.',
  withdrawTip2: '2. 네트워크 차단은 플랫폼이 귀하의 신청을 승인한 후 귀하의 출금을 확인합니다.',
  withdrawTip3: '3. 출금은 확인을 위해 최소 10개의 네트워크 블록이 필요합니다. 확인 후 귀하의 계정에 자금이 자동으로 입금됩니다.',
  coming: '곧 출시될 예정입니다.',
  createTeam: '준비금',
  angelFund: '엔젤펀드',
  ecology: '기관 및 생태계',
  presale: '사전 판매 릴리스',
  mechanism: '채굴 메커니즘',
  trading: '교환 거래',

  issuePrice: '발행가',
  minBuyPrice: '최소 가입',
  buyNum: '일일 구독',
  buyTotal: '총 일일 구독',
  Increment: '구독 증가',
  blockchain: '블록체인',

  sellTotal: '총 발행량',
  currentBuy: '현재 구독',
  lessMinTip: '최소 금액보다 작을 수 없습니다.',
  stakeAccount: '스테이킹 계정',
  serviceAccount: '서비스 계정',
  lock: '잠그다',
  lockPrice: '잠긴 가격',
  ieoHistory: 'IEO 역사',
  lockHistory: '잠금 기록',
  sellHistory: '판매 내역',
  stake: '스테이킹',
  service: '서비스',
  ieoBuyTip: '*IEO 알림: GPTH의 수는 제한되어 있습니다. 사용자의 IEO 신청을 검토하고 3시간마다 무작위로 추첨합니다. 상대적으로 금액이 많은 사용자는 GPTH를 구매할 확률이 더 높아집니다. 1인당 1일 최대 3회까지 구매할 수 있습니다.',
  ieoLockTip: '*잠금 가격: 사용자는 GPTH의 가격을 잠그기 위해 USDT를 담보 통화로 사용해야 하며, 담보 비율은 GPTH 가치의 30%입니다. GPTH가 출시된 후 사용자는 당시 고정된 가격으로 GPTH를 판매할 수 있습니다.',
  ieoSellTip: '*IEO 판매: GPTH 판매는 GPTH 가치의 10%를 서비스 수수료로 요구합니다. GPTH 매도 후 교환한 USDT는 20일 후 동결 해제되며, 약정한 USDT는 20일 후 동결 해제됩니다.',
  whitePaper: '백지',
  cost: '비용',
  currentEstimate: '현재 평가',
  stakeNum: '스테이킹 금액',
  estimate: '평가',
  consume: '소비하다',

  seedSell: '시드 라운드',
  privateSell: '개인 라운드',
  openSell: 'KOL 라운드',
  ieoAward: '공개 라운드',
  ieoGrowUp: '팀',
  partner: '고문',
  consultant: '마케팅',
  ieoName: '유동성',
  conAward: 'AI 수익 창출',
  staking: '스테이킹',

  release: '풀어 주다',
  closedTime: '폐관시간',
  remark: '주목',

  totalProfit: '총 이윤',
  transferIn: '전입',
  transferOut: '송금',
  equity: '순자산',

  
  homeremind1: '인기 있는 암호화폐',
  homeremind2: '더 많은 시장 보기',
  homeremind3: '마지막 가격(USD)',
  homeremind4: '24시간 변경',
  homeremind5: '행동',
  homeremind6: '더보기',
  homeremind7: "사용자의 최고의 선택",
  homeremind8: '24시간 거래량',
  homeremind9: '프라임 가상자산',
  homeremind10: '우리의 핵심 제품',
  homeremind11: '선택할 수 있는 다양한 거래 도구',
  homeremind12: '점',
  homeremind13: '700개 이상의 암호화폐 거래 가능',
  homeremind14: '선물 거래로 경험을 업그레이드하세요',
  homeremind15: 'FTZINC Earn',
  homeremind16: '업계 최고의 APY',
  homeremind17: '우리의 다양한 서비스',
  homeremind18: '다양한 서비스로 무한한 가능성을 탐험해보세요',
  homeremind19: 'IEO 구독',
  homeremind20: "최고의 사전 판매 암호화폐",
  homeremind21: 'VIP 고객 서비스',
  homeremind22: '7*24시간',
  homeremind23: '지역 사회',
  homeremind24: '우리와 함께 부의 기회를 찾아보세요',
  homeremind25: '이동 중에도 거래하세요. 언제 어디서나.',
  homeremind26: '우리 앱과 데스크톱 클라이언트로 최신 정보를 받아보세요.',
  homeremind27: '소셜 미디어에서 우리를 팔로우하세요',
  homeremind28: '최신 뉴스를 받아보세요',
  homeremind29: '언제 어디서나 거래하세요',
  homeremind30: 'iOS, Android 또는 API로 FTZINC을 사용해 보세요.',


  ieoDes: `디지털 자산 스마트 애플리케이션 체인(DAS)은 블록체인 기술을 기반으로 디지털 자산 스마트 애플리케이션 생태계를 구축하여 기존 자산 순환 장벽을 허물고자 합니다.`,
  ieoDes1: `개인 자산을 분산화함으로써 사용자에게 다양한 온체인 자산 운영 서비스를 제공하여 효율적인 자산 금융, 부가가치 창출, 담보 제공, 대출 서비스를 가능하게 합니다. 이를 통해 사용자는 안정적이고 높은 수익을 얻을 수 있으며, 디지털 자산 분야의 혁신, 개발 및 규정 준수 애플리케이션을 촉진합니다.`,

  ieoDes10: `에너지 생태계 비축 스마트 체인(ERS)은 블록체인 기술과 글로벌 에너지 생태계 비축량 요구를 통합한 혁신적인 블록체인 프로젝트입니다. 핵심 목표는 전 세계적인 에너지 부족 사태 및 예측 불가능한 상황 발생 시 에너지 공급 안보 문제를 해결하는 것입니다.`,
  ieoDes11: `이 프로젝트는 여러 국가의 업계 리더들로 구성된 핵심 팀을 기반으로 분산형 에너지 생태계 비축 스마트 플랫폼을 구축합니다. 이 플랫폼은 연구 개발, 응용, 보안 및 운송을 포함한 에너지 산업 전체 공급망을 연결합니다. 토큰 경제 시스템을 통해 생태계 공동 구축을 장려하고, 에너지 자원의 지능형 배분, 생태계 저장 및 글로벌 순환을 실현합니다.`,
  ieoDes12: `이 프로젝트는 생태계의 유일한 토큰으로 ERS 토큰을 발행합니다. 과학적인 토큰 배분과 명확한 상장 로드맵을 통해 프로젝트 구현 및 생태계 발전을 촉진하고, 글로벌 에너지 안보를 위한 블록체인 기술 솔루션을 제공합니다.`,





  foundingTeam: '창립팀',
  managementTeam: '관리팀',
  investors: '투자자',
  ecologicalFund: '생태기금',
  presaleNew: '사전 판매',
  stakingNew: '스테이킹',
  publicTrading: '공개거래',

  aboutName: 'FTZINC 소개',
  aboutContent: `<p><strong>FTZINC의 오늘</strong></p><p>FTZINC는 미국, 영국, 호주, 키프로스, 지브롤터, 폴란드, 불가리아, 세이셸에 지사를 둔 글로벌 기업입니다. 단기간 내에 유럽에서 가장 빠르게 성장하는 투자 거래 플랫폼 중 하나로 자리매김했으며, 매년 세 자릿수 성장률을 기록하고 있으며, 단 2년 만에 글로벌 팀 규모를 5배로 성장시켰습니다.</p><p>하지만 무엇보다도 FTZINC는 '사람'을 중시하는 기업입니다. 기술과 혁신을 기반으로 사람들이 잠재력을 최대한 발휘할 수 있도록 지원하는 플랫폼을 구축해 왔습니다.</p><p>새로운 기술을 배우고 싶든, 부를 늘리고 싶든, 기업의 행동에 책임을 묻고 싶든, FTZINC는 여러분의 거래 및 투자 목표 달성을 위해 최선을 다하겠습니다.</p><p>영국 금융감독청(FCA), 키프로스 증권거래위원회(SEC), 호주 증권투자위원회(SEC), 세이셸 금융감독청(FSA), 바하마 증권위원회의 인가 및 규제를 받는 수상 경력에 빛나는 글로벌 투자 거래 플랫폼을 신뢰하세요.</p><p>저희는 탁월한 24시간 연중무휴 고객 서비스와 투명한 가격 책정, 수수료 없음, 숨겨진 비용 없음, 낮은 익일 거래 수수료, 경쟁력 있는 스프레드를 약속드립니다.</p><p> </p><p><strong>FTZINC의 비전</strong></p><p>수십 년 동안 금융 서비스는 부자들에 의해, 부자들을 위해 운영되어 왔습니다. FTZINC의 창립자들은 이러한 상황을 바꾸고자 했습니다. 저희의 사명은 기존 금융 시스템을 혁신하여 거래 접근성을 높이는 것이었습니다.</p><p>저희는 사람들이 금융 시장에 접근할 수 있도록 하는 것을 목표로 했습니다. 이 단순한 아이디어에서 혁명이 탄생했습니다. 평범한 사람들이 주도하는 이 혁명은 그들의 삶과 재정적 미래, 그리고 무엇보다도 세상의 미래에 변화를 가져왔습니다.</p><p>따라서 개인 투자자들이 세계에서 가장 가치 있는 기업 중 하나를 만들기 위해 테슬라를 지지하기 시작했을 때, 그들은 단순히 혁신적인 기술을 갖춘 성장주에 투자한 것이 아니라 더 나은 미래, 더 지속 가능한 미래에 대한 약속에 투자한 것이었습니다. 기후 활동가와 정치인들의 역할에도 불구하고, 테슬라의 주가는 화석 연료를 사용하는 자동차 산업 전체가 전기차로 전환되는 데 결정적인 역할을 했습니다.</p><p>그리고 FTZINC는 항상 개인 투자자 혁명을 지원하고 주도하며 그 자리에 있었습니다. 2016년 출범 이후, FTZINC는 기술의 힘을 활용하여 거래 및 투자 옵션을 확대해 왔으며, 이는 구식의 진입 장벽을 제거하는 방식입니다.</p><p>오늘날, FTZINC의 글로벌 웹 및 앱 기반 플랫폼은 400만 명이 넘는 트레이더들이 삶, 재정적 미래, 그리고 세상에 변화를 가져오려는 노력을 지원하고 있습니다.</p>`,

  detailName0: '입금',
  detailName1: '철회',
  detailName2: '동결',
  detailName3: '고정 해제',
  detailName4: '현물시장 거래',
  detailName5: '현물 한도 거래',
  detailName6: '계약-시장 거래',
  detailName7: '계약 한도 거래',
  detailName8: '계약 종료',
  detailName9: 'IEO',
  detailName10: '입금',
  detailName11: '동결-철회',
  detailName12: '감소-철회',
  detailName13: '환불-출금 거부됨',
  detailName14: '이전',
  detailName15: '계약 개시',
  detailName16: '변제',
  detailName17: '환불-출금 취소됨',
  detailName19: '담보 대출 동결',
  detailName20: '담보 대출 거부',
  detailName21: '담보 대출',
  detailName22: '담보 대출 상환',
  detailName23: '담보 대출 정산 완료',

  usersAgreementsTitle: '사용자 계약',
  usersAgreements: `<p>1. FTZINC는 글로벌블록체인 자산거래 매니아를 위해제공됩니다. 본 약관은귀하의 권리와 이익과 중요한 관계가 있거나 있을 수 있는 조항을 명시하고 있으며, 플랫폼이 책임의 면제또는 제한을 갖고 있거나 가질 수 있는 조항을 주의 깊게 살펴보시기 바랍니다. 귀하는 본 서비스를 수락하기 위해본 플랫폼의 사용자로 등록하기전에 본 계약의 모든 내용을 완전히 읽고, 이해하고, 수락했음을 확인합니다. 이 서비스를 사용하면 귀하는본 계약의 모든 조항을 준수하는 데 동의하게됩니다.</p><p>2. 귀하는 본 플랫폼이 본 약관의내용을 일방적으로 언제든지 변경할수 있는 권리가 있으며, 귀하에게별도의 통지 없이 이를 업데이트하여 서비스 약관페이지에 표시할 수 있다는 점에 동의합니다. 본약관의 변경된 내용이 공지된 후에도 서비스를 계속 이용하는경우, 이는 귀하가개정된 약관의 내용을 충분히 읽고, 이해하고, 동의한 것으로 간주되며, 개정된약관의 내용에 따라 서비스를 이용하게 됩니다. ; 귀하는 개정된 약관의 내용에 동의하지 않는 경우서비스 이용을 중단해야 합니다.</p><p>3. 귀하는 본 계약을 수락하고 본 플랫폼의사용자로 등록하는 데 동의하면귀하가 18세에 도달했음을보장합니다. 본 계약의내용은 해당 국가 또는 지역의 법률에 의해 제외되지 않습니다. 위의 조건을 충족하지 못하는 경우, 즉시 등록을 해지하거나 서비스 이용을중단해야 합니다.</p><p>1. 계정 이용 제한</p><p>1.1 귀하는 본 서비스를 이용할 때해당 국가 또는 지역의 법률, 규정및 관련 국제 관행을 준수해야 하며, 본 서비스를 불법적인 목적(거래 품목의 거래 금지 또는 제한 포함)으로이용해서는 안 됩니다. 불법적인방법 이 서비스를 이용하세요.</p><p>1.2 귀하는 본 서비스를 이용하여 타인의정당한 권리와 이익을 침해하는 행위에 가담해서는안 됩니다. 그렇지않을 경우 본 플랫폼은 본 서비스를조사, 지연, 해결 또는 거부할 권리가 있으며 귀하는 관련 모든 책임을 독립적으로 부담해야 합니다. 법적 책임으로 인해 본플랫폼 또는 본 플랫폼 직원이 부상을 입은 경우 귀하는 보상 책임을 져야 합니다.</p><p>위의 조치에는 다음이 포함되지만이에 국한되지는 않습니다.</p><p>ㅏ. 타인의명예, 사생활, 영업비밀 등 정당한권익을 침해하는 행위.</p><p>비. 법률에규정되거나 합의된 비밀유지 의무를 위반한경우.</p><p>씨. 타인의이름으로 서비스를 이용하십시오.</p><p>디. 자금세탁, 테러 자금조달, 마약 거래또는 플랫폼에서 서비스를 사용해서는안 된다고 판단하는 기타 상황과같은 불법 거래에 참여합니다.</p><p>이자형. 컴퓨터바이러스를 포함하거나 서비스 시스템및 데이터를 침해할 수있는 행위를 하는 행위</p><p>에프. 귀하또는 상대방이 선언한 거래내용과 일치하지 않거나 사실이아닌 거래를 수행합니다.</p><p>g. 합법적인 이유로 본플랫폼에서 부적절하다고 간주되는 기타행위.</p><p>2. FTZINC 중개 서비스</p><p>포함하는:</p><p>2.1 에스크로: 귀하는이 서비스에서 지정한 방법을사용하여 귀하의 FTZINC 계정(이 플랫폼에서 지원하는 비트코인및 기타 디지털 자산 포함, 아래와동일)을 충전할수 있으며 이 플랫폼이 귀하를 대신하여계정을 보관하도록 맡길 수있습니다.</p><p>2.2 결제: 이플랫폼에서 귀하와 다른 사용자 간의 거래에 대해 플랫폼은 디지털 자산에대한 거래 결제 서비스를 제공하는 제3자 역할을 합니다(다양한국가의 법정 통화는 포함되지 않음). 귀하는 플랫폼에서 정산한 후에는본 계약에 동의하지 않는 한지불금을 되돌릴 수 없다는 데 동의합니다.</p><p>2.3 출금: 귀하는이 플랫폼에 관리를 맡긴디지털 자산의 금액을 지불하도록 이 플랫폼에요청할 수 있습니다. 플랫폼에코인 출금 지시를 보낼 때 플랫폼에서 설정한 유효한인증 방법을 확인해야 합니다. 플랫폼은 지정된 시간(특히 플랫폼 규정에 따라) 내에성공적인 검증 지시를 받게 되며, 해당수량의 자산이 귀하가 제공한 유효한 배송 주소로 이전됩니다.</p><p>2.4 <span style="font-family: 宋体;">조회</span>: <span style="font-family: 宋体;">귀하는</span> <span style="font-family: 宋体;">본</span> <span style="font-family: 宋体;">시스템에서귀하의</span> <span style="font-family: 宋体;">계좌이름에</span> <span style="font-family: 宋体;">따른거래</span> <span style="font-family: 宋体;">기록을실시간으로</span> <span style="font-family: 宋体;">조회할수</span> <span style="font-family: 宋体;">있습니다</span>.</p><p>2.5 <span style="font-family: 宋体;">금전독점</span>: <span style="font-family: 宋体;">플랫폼은</span> <span style="font-family: 宋体;">귀하가이</span> <span style="font-family: 宋体;">플랫폼에지불한</span> <span style="font-family: 宋体;">디지털자산</span> <span style="font-family: 宋体;">지분을귀하의</span> <span style="font-family: 宋体;">계정에속하게</span> <span style="font-family: 宋体;">유지하며귀하의</span> <span style="font-family: 宋体;">지시가아닌</span> <span style="font-family: 宋体;">다른목적으로</span> <span style="font-family: 宋体;">사용하지않습니다</span>.</p><p>3. 등록관련</p><p>귀하는 이 웹사이트에 직접 등록하고이 플랫폼에서 제공하는 계정을얻어야 합니다. 당신은동의:</p><p>3.1 플랫폼 요구 사항에 따라 정확하게 제공하고 계정을얻은 후 적시에 정확하고 최신의 완전한확인 정보를 업데이트하십시오. 플랫폼에서귀하가 제공한 정보가 최신이 아니거나 불완전하거나부정확하다고 판단할 이유가 있고 플랫폼에서 귀하에게 관련정보 제공을 요구하는 경우, 귀하가 제때에 정보를 제공할 수 없는 경우 당사는 귀하의 정보 제공을 거부할 권리가 있습니다. 이웹사이트에 접속하고 귀하의 계정을종료하거나 정지하십시오.</p><p>3.2 귀하는 귀하가 제공한 이메일 주소 및 기타 연락처 정보를 정확하고 시기적절하게업데이트하여 이 플랫폼이 시기적절하고효과적인 방식으로 귀하에게 연락할수 있도록 해야 합니다. 이러한연락 방법을 통해 귀하에게 연락할 수없기 때문에 본 서비스를 사용하는 동안발생하는 손실, 비용증가 및 기타 불리한 결과에 대한 책임은 전적으로 귀하에게 있습니다. 귀하는 귀하가 제공한 연락처 정보의 유효성을 유지할 의무가있음을 이해하고 이에 동의합니다. 업데이트해야 할 변경사항이 있는 경우 이 플랫폼의 요구 사항에따라 작동해야 합니다.</p><p>3.3 귀하의 계정에는 타인의 신원인증 정보, 타인의은행 계좌 등의 사용을 포함하되 이에 국한되지않는 오해의 소지가 있거나 사기적인 정보가 포함되어서는안 됩니다.</p><p>3.4 귀하가 정보(본플랫폼 계정에 연결된 휴대폰 번호, 이메일주소 등을 포함하되 이에 국한되지않음)를 적시에업데이트하지 않아 서비스를 제공할 수없거나 제공 시 오류가 발생하는 경우 , 귀하는 이를 거래 취소 또는 결제 거부 사유로 사용해서는 안 되며, 이로 인해 발생하는 모든 결과는귀하가 부담해야 하며, 이 플랫폼은 어떠한 책임도지지 않습니다.</p><p>3.5 귀하는 귀하의 계정에 대한 책임이 있으며 귀하만이 귀하의 계정을사용할 수 있습니다.</p><p>3.6 귀하는 귀하가 시민권 또는 민사행위 능력의 전부또는 일부를 상실한 경우, 본플랫폼이 유효한 법적 문서(유효한법원 판결을 포함하되 이에 국한되지않음)에 따라귀하의 계정과 관련된 자금을 처분할 권리가 있음에 동의합니다. 유효한유언장 등) 조항.</p><p>3.7 당사는 언제든지 귀하에게 신원확인 절차를 완료하도록 요청할 수있으며, 필요하다고판단되는 경우 이 플랫폼에 추가 신원문서를 제출하도록 요구할 수도있습니다. 신원 확인을완료하지 못하는 것은 본 계약을 위반하는 것으로 간주됩니다.</p><p>3.8 <span style="font-family: 宋体;">귀하가다음</span> <span style="font-family: 宋体;">사항을위반하는</span> <span style="font-family: 宋体;">경우당사는</span> <span style="font-family: 宋体;">귀하의계정</span> <span style="font-family: 宋体;">또는당사가</span> <span style="font-family: 宋体;">제공하는기타</span> <span style="font-family: 宋体;">서비스에대한</span> <span style="font-family: 宋体;">귀하의접근을</span> <span style="font-family: 宋体;">폐쇄</span>, <span style="font-family: 宋体;">정지</span> <span style="font-family: 宋体;">또는</span> <span style="font-family: 宋体;">제한할수</span> <span style="font-family: 宋体;">있으며</span>, <span style="font-family: 宋体;">귀하의</span> <span style="font-family: 宋体;">디지털</span> <span style="font-family: 宋体;">자산잔고</span> <span style="font-family: 宋体;">사용을</span> 180<span style="font-family: 宋体;">일</span> <span style="font-family: 宋体;">동안</span>(<span style="font-family: 宋体;">또는</span> <span style="font-family: 宋体;">법원명령이나</span> <span style="font-family: 宋体;">기타법적</span> <span style="font-family: 宋体;">절차에따라</span> <span style="font-family: 宋体;">그이상</span>) <span style="font-family: 宋体;">제한할</span> <span style="font-family: 宋体;">수있습니다</span>. <span style="font-family: 宋体;">본</span> <span style="font-family: 宋体;">서비스약관</span> <span style="font-family: 宋体;">또는기타</span> <span style="font-family: 宋体;">계약</span>. <span style="font-family: 宋体;">귀하의</span> <span style="font-family: 宋体;">계정과</span> <span style="font-family: 宋体;">관련된위험을</span> <span style="font-family: 宋体;">평가할때</span> <span style="font-family: 宋体;">당사는독점적인</span> <span style="font-family: 宋体;">위험평가</span> <span style="font-family: 宋体;">모델을사용할</span> <span style="font-family: 宋体;">수도있으며</span> <span style="font-family: 宋体;">위험도가높은</span> <span style="font-family: 宋体;">사용자는본</span> <span style="font-family: 宋体;">계약을위반한</span> <span style="font-family: 宋体;">것으로간주됩니다</span>.</p><p>3.9 <span style="font-family: 宋体;">본계약</span> <span style="font-family: 宋体;">조건에따라</span> <span style="font-family: 宋体;">귀하가이전</span> <span style="font-family: 宋体;">시점에본</span> <span style="font-family: 宋体;">계약또는</span> <span style="font-family: 宋体;">기타계약을</span> <span style="font-family: 宋体;">위반했다고판단하는</span> <span style="font-family: 宋体;">경우당사는</span> <span style="font-family: 宋体;">서비스에대한</span> <span style="font-family: 宋体;">귀하의계정</span> <span style="font-family: 宋体;">및디지털</span> <span style="font-family: 宋体;">자산잔액의</span> <span style="font-family: 宋体;">사용을폐쇄</span>, <span style="font-family: 宋体;">정지</span> <span style="font-family: 宋体;">또는제한할</span> <span style="font-family: 宋体;">수도있습니다</span>. <span style="font-family: 宋体;">당신은</span> <span style="font-family: 宋体;">및기타</span> <span style="font-family: 宋体;">조치를사용하고</span> <span style="font-family: 宋体;">있습니다</span>.</p><p>4. 계정 보안</p><p>이 계정과 비밀번호를 사용한 모든운영과 발언에 대한 책임은 전적으로 귀하에게 있습니다. 당신은 동의:</p><p>4.1 이 플랫폼은 귀하의 계정로그인 이름 및 비밀번호와 같은 지침을통해 귀하의 지침을 인식합니다. 귀하는귀하의 계정 로그인 이름과 비밀번호를 올바르게 관리해야하며, 비밀번호 공개로인해 발생하는 손실에 대한책임은 귀하에게 있습니다. 귀하는 귀하의 계정 로그인 이름과 비밀번호를 다른 사람에게공개하지 않으며 다른 사람의 로그인 이름과 비밀번호를 사용하지 않을것을 약속합니다. 이플랫폼은 또한 이 서비스를 사용하여 귀하의지침을 식별하는 데 사용하는다른 제품이나 장비를 적용할수도 있습니다. 귀하는이러한 제품이나 장비를 귀하의관리하에 적절하게 보관하거나귀하의 통제하에 있어야 합니다. 본 제품이나 장비의 분실로인한 손실은 귀하의 책임입니다.</p><p>4.2 귀하는 (a) 다른사람이 귀하의 계정 로그인 이름과 비밀번호를 부정하게 사용하거나훔쳤거나 기타 무단 사용을 발견한 경우 효과적인 방법으로 즉시플랫폼에 알리고 관련 서비스를 중단하도록플랫폼에 요청해야 합니다. 그리고 (b) 지속적인로그인 기간이 끝나면 올바른 단계에 따라 웹사이트를 떠나는지 확인합니다. 본 플랫폼은 귀하가 본조항을 준수하지 않음으로 인해발생하는 손실, 손해및 기타 불리한 결과에 대해 책임을 지지 않습니다. 귀하는이 플랫폼이 귀하의 요청에대한 조치를 취하는 데 합리적인 시간 제한이필요하다는 것을 이해합니다. 이에앞서 플랫폼은 실행된 지침및/또는 이로인해 발생한 손실에 대해 책임을 지지 않습니다.</p><p>4.3 법적 규정이나 사법 판단이없고 본 플랫폼의 동의 없이귀하의 계정 로그인 이름과 비밀번호, 계정은어떤 방식으로든 양도, 증여 또는 상속될 수 없습니다(관련재산권 제외).</p><p>4.4 귀하는 운영 및 거래 보안의 필요에 따라 본 플랫폼이 본 서비스의일부 기능 제공을 일시적으로 중단하거나제한하거나 새로운 기능을 제공할 수 있다는 데 동의합니다. 기능이축소, 증가 또는변경된 경우에도 귀하가 본서비스를 계속 사용하는 한 이는귀하가 본 약관 또는 변경된 약관에 동의한다는 것을 의미합니다.</p><p>4.5 <span style="font-family: 宋体;">본플랫폼은</span> <span style="font-family: 宋体;">귀하가플랫폼</span> <span style="font-family: 宋体;">제품또는</span> <span style="font-family: 宋体;">서비스를사용하는</span> <span style="font-family: 宋体;">실제거래</span> <span style="font-family: 宋体;">배경과목적을</span> <span style="font-family: 宋体;">알권리가</span> <span style="font-family: 宋体;">있습니다</span>. <span style="font-family: 宋体;">귀하는</span> <span style="font-family: 宋体;">플랫폼에서</span> <span style="font-family: 宋体;">요구하는진실되고</span> <span style="font-family: 宋体;">포괄적이며정확한</span> <span style="font-family: 宋体;">정보를진실되게</span> <span style="font-family: 宋体;">제공해야합니다</span>. <span style="font-family: 宋体;">플랫폼이</span> <span style="font-family: 宋体;">귀하가허위</span> <span style="font-family: 宋体;">거래정보를</span> <span style="font-family: 宋体;">제공했다고의심할</span> <span style="font-family: 宋体;">만한합리적인</span> <span style="font-family: 宋体;">근거가있는</span> <span style="font-family: 宋体;">경우</span>, <span style="font-family: 宋体;">이</span> <span style="font-family: 宋体;">플랫폼은</span> <span style="font-family: 宋体;">귀하가사용하는</span> <span style="font-family: 宋体;">제품또는</span> <span style="font-family: 宋体;">서비스의일부</span> <span style="font-family: 宋体;">또는전체</span> <span style="font-family: 宋体;">기능을일시적</span> <span style="font-family: 宋体;">또는영구적으로</span> <span style="font-family: 宋体;">제한할권리가</span> <span style="font-family: 宋体;">있습니다</span>.</p><p>4.6 <span style="font-family: 宋体;">귀하는귀하의</span> <span style="font-family: 宋体;">계정과디지털</span> <span style="font-family: 宋体;">자산의안전을</span> <span style="font-family: 宋体;">위해본</span> <span style="font-family: 宋体;">계약</span>, <span style="font-family: 宋体;">법률</span> <span style="font-family: 宋体;">및</span> <span style="font-family: 宋体;">규정</span>, <span style="font-family: 宋体;">법률</span> <span style="font-family: 宋体;">문서의</span> <span style="font-family: 宋体;">조항</span>, <span style="font-family: 宋体;">관리</span> <span style="font-family: 宋体;">권한에</span> <span style="font-family: 宋体;">따른정부</span> <span style="font-family: 宋体;">요구사항</span> <span style="font-family: 宋体;">및플랫폼</span> <span style="font-family: 宋体;">자체판단에</span> <span style="font-family: 宋体;">따라영향을</span> <span style="font-family: 宋体;">미칠수</span> <span style="font-family: 宋体;">있다는점에</span> <span style="font-family: 宋体;">동의합니다</span>. <span style="font-family: 宋体;">귀하의</span> <span style="font-family: 宋体;">계정</span> <span style="font-family: 宋体;">위험이발생할</span> <span style="font-family: 宋体;">경우플랫폼은</span> <span style="font-family: 宋体;">귀하의이름으로</span> <span style="font-family: 宋体;">된계정</span> <span style="font-family: 宋体;">전체또는</span> <span style="font-family: 宋体;">일부를동결할</span> <span style="font-family: 宋体;">권리</span>, <span style="font-family: 宋体;">즉</span> <span style="font-family: 宋体;">해당</span> <span style="font-family: 宋体;">계정중</span> <span style="font-family: 宋体;">일부또는</span> <span style="font-family: 宋体;">전부를일시적으로</span> <span style="font-family: 宋体;">폐쇄할권리가</span> <span style="font-family: 宋体;">있습니다</span>. <span style="font-family: 宋体;">동결의</span> <span style="font-family: 宋体;">반대</span> <span style="font-family: 宋体;">과정은동결</span> <span style="font-family: 宋体;">해제입니다</span>. <span style="font-family: 宋体;">즉</span>, <span style="font-family: 宋体;">플랫폼은</span> <span style="font-family: 宋体;">동결된</span> <span style="font-family: 宋体;">계정의동결을</span> <span style="font-family: 宋体;">종료합니다</span>. <span style="font-family: 宋体;">동결</span> <span style="font-family: 宋体;">발생</span> <span style="font-family: 宋体;">시동결</span> <span style="font-family: 宋体;">해제를신청하는</span> <span style="font-family: 宋体;">경우플랫폼은</span> <span style="font-family: 宋体;">본조항에</span> <span style="font-family: 宋体;">따라앞서</span> <span style="font-family: 宋体;">언급한동결</span> <span style="font-family: 宋体;">사유에따라</span> <span style="font-family: 宋体;">전체또는</span> <span style="font-family: 宋体;">부분동결</span> <span style="font-family: 宋体;">해제를허용할지</span> <span style="font-family: 宋体;">여부를결정할</span> <span style="font-family: 宋体;">권리가있습니다</span>. <span style="font-family: 宋体;">귀하는</span> <span style="font-family: 宋体;">동결해제</span> <span style="font-family: 宋体;">신청이반드시</span> <span style="font-family: 宋体;">허용되는것은</span> <span style="font-family: 宋体;">아니라는점을</span> <span style="font-family: 宋体;">충분히이해해야</span> <span style="font-family: 宋体;">하며</span>, <span style="font-family: 宋体;">동결</span> <span style="font-family: 宋体;">해제</span> <span style="font-family: 宋体;">시신청은</span> <span style="font-family: 宋体;">본플랫폼의</span> <span style="font-family: 宋体;">관련요구</span> <span style="font-family: 宋体;">사항에협조하여</span> <span style="font-family: 宋体;">귀하의신원을</span> <span style="font-family: 宋体;">확인하고신원</span> <span style="font-family: 宋体;">정보</span>, <span style="font-family: 宋体;">신분증</span>, <span style="font-family: 宋体;">여권</span>, <span style="font-family: 宋体;">기타</span> <span style="font-family: 宋体;">유효한</span> <span style="font-family: 宋体;">신분증및</span> <span style="font-family: 宋体;">본플랫폼에서</span> <span style="font-family: 宋体;">요구하는기타</span> <span style="font-family: 宋体;">정보또는</span> <span style="font-family: 宋体;">문서</span>.</p><p>5 계정 사용 규칙</p><p>이 서비스를 사용할 때귀하의 법적 권리를 효과적으로 보호하기 위해귀하는 다음 규칙을 이해하고 이에 동의합니다.</p><p>5.1 귀하가 이 서비스를 사용하면 귀하는지정된 조건을 충족하는 사용자와 귀하사이의 디지털 자산 정산을 위한 대리인 역할을 할 수 있도록 이 플랫폼을 승인하게 됩니다.</p><p>5.2 본 플랫폼은 다음 두가지 방법으로 귀하의 지시를수락합니다. 첫째, 귀하는 본 웹 사이트에서 귀하의 계정이름과 비밀번호를 사용하여 귀하의계정에 로그인하고 본 서비스의미리 설정된 프로세스에 따라 거래상태 또는 지시를 수정하거나 확인합니다. 둘째, 귀하는귀하가 등록할 때 계정 이름 또는 계정에 연결된 계정으로 귀하에게 전용된이메일, 휴대폰 또는기타 통신 도구를 통해 시스템에 전송된 정보에회신합니다. 위의 두가지 방법 중 어느 방법을 통해 플랫폼에 지시를 보내든, 이를 철회하거나 취소할 수없으며 플랫폼이 귀하를 대신하여돈을 지불하거나 받거나 기타계정 작업을 수행하는 유일한 지시가됩니다. 그것은 당신자신의 지시로 간주됩니다. 위지침을 플랫폼이 충실하게 실행하여발생하는 모든 결과에 대한 책임은 귀하에게 있습니다. 본 계약에 달리 규정된 경우를 제외하고, 귀하가제3자와 거래분쟁이 있는 경우 귀하는 본 플랫폼이 스스로 판단하고분쟁 금액의 전부 또는 일부를 거래 당사자 중 한 명 또는 두 명 모두에게 지불하도록결정할 수 있는 권한을 부여합니다.</p><p>5.3 본 플랫폼은 귀하에게 거래진행 상황을 알리고 이메일(또는휴대폰으로 전송된 SMS 또는전화 통화 등)을통해 다음 단계를 수행하도록 요청하지만, 본 플랫폼은 귀하가 이메일을받거나 받을 수 있음을 보장하지 않습니다. 적시에(또는휴대폰으로 전송된 문자 메시지 또는 전화 통화 등) 어떠한결과도 초래하지 않으므로 거래과정에서 거래 작업을 확인하고 수행하려면적시에 이 웹 사이트에 로그인해야합니다. 본 플랫폼은귀하가 적시에 거래 상태를 확인, 수정또는 확인하지 않거나 관련신청서를 제출하지 않음으로 인해발생하는 모든 분쟁이나 손실에 대해책임을 지지 않습니다.</p><p>5.4 본 계약에 따른 디지털 자산의 양도는 해당 네트워크를 통해 이루어지며, 귀하는 디지털 자산을 양도하는 동안 합리적인시간을 이해하고 이에 동의합니다.</p><p>5.5 거래 위험</p><p>ㅏ. 본서비스 이용 시 귀하 또는 귀하의 거래 지시에 실수(가격, 수량, 기타요소를 포함하되 이에 국한되지않음)로 인해거래 손실이 발생하는 경우 손실에대한 책임은 귀하에게 있습니다.</p><p>비. 귀하의잘못으로 인해 발생하는 모든 손실은귀하가 부담해야 합니다. 결함에는 다음이 포함되지만이에 국한되지는 않습니다: 거래 프롬프트를 따르지 않음, 제때에 거래 작업을 수행하지 못함, 비밀번호를 잊어버리거나유출함, 타인이 비밀번호를해독함, 타인이 귀하의컴퓨터를 사용함 침입.</p><p>씨. 이서비스를 이용할 때 귀하가 웹사이트 거래 시스템이나규칙에서 발견되지 않은 잠재적인허점으로 인해 부당한 이익을 얻은 경우, 본사이트는 이를 복구하기 위해 귀하에게연락할 권리가 있으며 귀하는 효과적으로 협조해야 합니다. 그렇지 않은 경우 본 사이트는 다음을 포함한상환 조치를 취합니다. 이에국한되지 않고 계좌 거래 제한, 계좌자금 동결, 소송등이 취해질 수 있습니다. 귀하가효과적으로 협조하지 못하여 당사에발생한 상환 비용도 귀하가 부담합니다.</p><p>5.6. 귀하는 이익, 상품, 데이터 등의 손실을 포함하되 이에 국한되지않는 다음 상황으로 인해 발생한손해에 대해 이 플랫폼이 책임을 지지않는다는 것을 이해하고 이에 동의합니다.</p><p><span style="font-family: 宋体;">ㅏ</span>. <span style="font-family: 宋体;">본</span> <span style="font-family: 宋体;">플랫폼은</span> <span style="font-family: 宋体;">귀하가본</span> <span style="font-family: 宋体;">계약의명시적</span> <span style="font-family: 宋体;">조항과정신을</span> <span style="font-family: 宋体;">위반했다고판단하는</span> <span style="font-family: 宋体;">경우를포함하되</span> <span style="font-family: 宋体;">이에국한되지</span> <span style="font-family: 宋体;">않는일방적인</span> <span style="font-family: 宋体;">판단에따라</span> <span style="font-family: 宋体;">본서비스</span> <span style="font-family: 宋体;">또는귀하의</span> <span style="font-family: 宋体;">이름으로계정의</span> <span style="font-family: 宋体;">일부제공을</span> <span style="font-family: 宋体;">일시중지</span>, <span style="font-family: 宋体;">중단</span> <span style="font-family: 宋体;">또는종료할</span> <span style="font-family: 宋体;">권리가있습니다</span>. <span style="font-family: 宋体;">동의하고</span> <span style="font-family: 宋体;">데이터를삭제하세요</span>.</p><p><span style="font-family: 宋体;">비</span>. <span style="font-family: 宋体;">본</span> <span style="font-family: 宋体;">플랫폼은</span> <span style="font-family: 宋体;">비정상적인거래나</span> <span style="font-family: 宋体;">법률또는</span> <span style="font-family: 宋体;">본계약의</span> <span style="font-family: 宋体;">조항에대한</span> <span style="font-family: 宋体;">의심또는</span> <span style="font-family: 宋体;">위반을발견한</span> <span style="font-family: 宋体;">경우사전</span> <span style="font-family: 宋体;">통지없이</span> <span style="font-family: 宋体;">귀하의이름으로</span> <span style="font-family: 宋体;">된계정의</span> <span style="font-family: 宋体;">사용을일시</span> <span style="font-family: 宋体;">중지하거나종료할</span> <span style="font-family: 宋体;">수있는</span> <span style="font-family: 宋体;">권리</span>(<span style="font-family: 宋体;">귀하의</span> <span style="font-family: 宋体;">이름으로</span> <span style="font-family: 宋体;">된계정의</span> <span style="font-family: 宋体;">사용을포함하되</span> <span style="font-family: 宋体;">이에국한되지</span> <span style="font-family: 宋体;">않음</span>)<span style="font-family: 宋体;">를</span> <span style="font-family: 宋体;">갖습니다</span>. <span style="font-family: 宋体;">결제</span> <span style="font-family: 宋体;">및미결제</span> <span style="font-family: 宋体;">거래에는거래</span> <span style="font-family: 宋体;">취소</span>, <span style="font-family: 宋体;">계좌</span> <span style="font-family: 宋体;">조정</span> <span style="font-family: 宋体;">등의제한</span> <span style="font-family: 宋体;">조치가취해지며</span>, <span style="font-family: 宋体;">본</span> <span style="font-family: 宋体;">서비스의기능</span> <span style="font-family: 宋体;">중일부</span> <span style="font-family: 宋体;">또는전부의</span> <span style="font-family: 宋体;">이용을거부합니다</span>.</p><p>6. 서비스 수수료</p><p>6.1 귀하가 이 서비스를 이용할 때이 플랫폼은 "계정서비스 요금 규칙"에따라 귀하에게 서비스 요금을청구할 권리가 있습니다. 본플랫폼은 서비스 수수료를 공식화하고조정할 권리가 있습니다. 구체적인서비스 요금은 귀하가 서비스를 사용할 때본 웹사이트에 나열된 청구방법에 대한 공지 또는 귀하와 플랫폼 간에 체결된 기타 서면 계약에 따라 달라집니다.</p><p>6.2 달리 명시하거나 합의하지 않는한, 귀하는 이플랫폼이 관리, 수집또는 지불을 위해 이 플랫폼에 위탁한 자금에서위의 서비스 수수료를 직접 공제할권리가 있다는 데 동의합니다.</p><p>7. 개인정보 보호</p><p>귀하가 본 계약에 동의하거나 본 서비스를사용하면 본 플랫폼이 다음 조건에따라 귀하의 개인 정보를 사용하고 공개한다는데 동의하는 것입니다.</p><p>7.1 계정 로그인 이름 및 비밀번호</p><p>회원가입 및 서비스가입 시 본인 확인을 위해 계정 로그인명과 비밀번호 설정을요청하고, 비밀번호 분실시 본인 확인을 위해 휴대폰 SMS인증, 실명인증 등을 설정해드립니다. 본인이 설정한비밀번호로만 계정을 사용할 수 있습니다. 귀하의비밀번호가 유출될 경우 귀하의 개인식별정보가 유출될 수있으며, 귀하에게 불리한법적 처벌을 받을 수 있습니다. 어떤이유로든 계정과 비밀번호가 잠재적 또는실제 위험에 처한 경우 즉시 플랫폼에 연락해야 합니다. 플랫폼이 조치를 취하기전에는 이에 대해 플랫폼이 책임을 지지않습니다.</p><p>7.2 등록정보</p><p>등록 시 전화번호, 이메일주소 등 관련 정보를 제공해야 합니다. 귀하에게 타겟 방식으로새로운 서비스와 기회를 제공하기위해 귀하는 이 플랫폼이 귀하의 연락처정보(휴대폰, 이메일 등을 포함하되 이에 국한되지않음)를 통해관련 알림 및 기타 상업용 전자 정보를 귀하에게 보낼 것임을이해하고 이에 동의합니다. .</p><p>7.3 거래 행위</p><p>귀하의 서비스 이용의 안전을 보장하고 서비스 품질을지속적으로 개선하기 위해 본플랫폼은 귀하의 로그인 및 본 서비스 이용과 관련된 정보를 기록하고 저장합니다. 그러나 본 플랫폼은 해당 정보를귀하에게 제공하지 않을 것을약속합니다. 제3자(당사자가달리 합의하지 않거나 법률및 규정에 의해 달리 규정되지 않는 한).</p><p>7.4 귀하는 법률 및 규정에 따라 귀하에게 보다 안전하고효과적으로 서비스를 제공하기 위해플랫폼이 귀하의 신원을 식별해야 하거나 플랫폼이귀하의 계정이 위험하다고 판단하는 경우플랫폼이 다음을 요구할 권리가 있다는 데 동의합니다. 신원정보(신분증, 호적부, 여권및 기타 서류 또는 기타 서류를 포함하되 이에 국한되지않음)를 제출하도록요청합니다. 본 계약에달리 규정된 경우를 제외하고,</p><p> </p><p>ㅏ. 사전에귀하의 명시적인 승인을 얻으십시오.</p><p>비. 본계약의 요구 사항에 따른 공개</p><p>씨. 법률및 규정에 따라</p><p>디. 정부당국의 요구 사항에 따라;</p><p>이자형. 본플랫폼의 합법적인 권리와 이익을보호하기 위해.</p><p>7.5 외부 링크</p><p><span style="font-family: 宋体;">본</span> 웹사이트에는다른 웹사이트에 대한 링크가포함되어 있지만, 본플랫폼은 다른 웹사이트의 개인정보 보호조치에 대해 책임을 지지 않습니다. 이플랫폼은 필요할 때마다 비즈니스 파트너나 공유브랜드 웹사이트를 추가할 수있습니다.</p><p>7.6 <span style="font-family: 宋体;">보안</span></p><p><span style="font-family: 宋体;">본</span> <span style="font-family: 宋体;">플랫폼은</span> <span style="font-family: 宋体;">본플랫폼이</span> <span style="font-family: 宋体;">보유한정보의</span> <span style="font-family: 宋体;">유실</span>, <span style="font-family: 宋体;">남용</span> <span style="font-family: 宋体;">및</span> <span style="font-family: 宋体;">변경을방지하기</span> <span style="font-family: 宋体;">위해기존</span> <span style="font-family: 宋体;">기술에따라</span> <span style="font-family: 宋体;">해당보안</span> <span style="font-family: 宋体;">조치만제공합니다</span>. <span style="font-family: 宋体;">이러한</span> <span style="font-family: 宋体;">보안조치에는</span> <span style="font-family: 宋体;">데이터를다른</span> <span style="font-family: 宋体;">서버에백업하고</span> <span style="font-family: 宋体;">사용자비밀번호를</span> <span style="font-family: 宋体;">암호화하는것이</span> <span style="font-family: 宋体;">포함됩니다</span>. <span style="font-family: 宋体;">이러한</span> <span style="font-family: 宋体;">보안</span> <span style="font-family: 宋体;">조치에도불구하고</span> <span style="font-family: 宋体;">본플랫폼은</span> <span style="font-family: 宋体;">해당정보의</span> <span style="font-family: 宋体;">절대적인보안을</span> <span style="font-family: 宋体;">보장하지않습니다</span>.</p><p>8. 시스템 중단 또는 장애</p><p>다음과 같은 상황으로 인해 시스템이정상적으로 작동하지 않아 다양한서비스를 이용할 수 없는 경우, 본플랫폼은 다음을 포함하되 이에 국한되지않는 손해에 대해 책임을 지지 않습니다.</p><p>8.1 플랫폼 웹사이트에 공지된 시스템종료 및 유지보수 기간 동안. 8.2 통신 장비가 데이터 전송에 실패했습니다.</p><p>8.3 태풍, 지진, 쓰나미, 홍수, 정전, 전쟁, 테러 공격 및 기타 불가항력 요인과 같은불가항력 요인으로 인해 본플랫폼의 시스템은 시스템 장애로인해 실행될 수 없습니다.</p><p>8.4 해커 공격, 컴퓨터바이러스 침입 또는 공격, 통신부서의 기술적 조정 또는 오작동, 웹사이트업그레이드, 정부 통제로인한 일시적 종료, 기타네트워크의 정상적인 작동에 영향을미치는 사유로 인한 서비스 중단 또는 지연.</p><p>8.5 사용자가 플랫폼에서승인하거나 승인하지 않은 방식으로플랫폼 서비스를 부적절하게운영하거나 사용합니다.</p><p>8.6 사용자의 컴퓨터 소프트웨어및 하드웨어, 통신선, 전원 공급선이 제대로 작동하지않습니다.</p><p>9. 책임 범위 및 책임 제한</p><p>본 플랫폼은 본 계약에명시된 책임 범위에 대해서만 책임을 집니다.</p><p>9.1 본 플랫폼의 사용자 정보는사용자 자신이 제공한 것이며 플랫폼은 정보의 정확성, 타당성 및 완전성을 보장할 수없습니다.</p><p>9.2 플랫폼은 귀하와 귀하의 (거래) 상대방에게동시에 플랫폼 서비스를 제공할 수있습니다. 귀하는 플랫폼에존재할 수 있는 행위로부터 실제적이거나잠재적인 이해 상충을 명시적으로 면제하는 데동의하며, 플랫폼이 플랫폼을제공한다고 주장할 수 없습니다. 서비스에법적 결함이 있습니다.</p><p>9.3 귀하가 이 서비스를 사용하여 데이터를다운로드하거나 얻는 경우, 귀하는이를 스스로 고려해야 하며 이에따른 위험은 귀하 자신의 책임입니다. 데이터다운로드로 인해 컴퓨터 시스템이 손상되거나데이터가 손실되는 경우 모든책임은 전적으로 귀하에게 있습니다.</p><p>9.4 귀하가 본 플랫폼과 그 직원으로부터또는 본 서비스를 통해 서면또는 구두 형식으로 얻은 조언과정보는 본 서비스에 대한 플랫폼의보증을 구성하지 않습니다.</p><p>10. 전체 계약</p><p>본 약관은 본 약관의 조항과 본 웹사이트에 게시된 "서비스 요금 규정" 및기타 규정으로 구성됩니다. 관련 용어를 인용하여 서로 참조할수 있습니다. 서로다른 이해가 있는 경우에는 본 계약의조건이 우선 적용됩니다. 귀하가본 계약을 이해하고 이에 동의하는경우 귀하는 본 계약의 모든 구성요소를 이해하고 동의하는것입니다. 이 서비스를사용하면 귀하와 이 플랫폼은 본 계약의모든 구성 요소에 구속됩니다. 본계약 내용의 일부가 관할권을 가진 사법당국에 의해 불법으로 간주되는 경우에도다른 내용의 유효성에는 영향을 미치지않습니다.</p><p>11. 상표 및 지적재산권 보호</p><p>11.1 저작물, 사진, 파일, 정보, 자료, 웹사이트구조, 웹사이트 화면배치, 웹 디자인을포함하되 이에 국한되지 않는 본웹사이트의 모든 콘텐츠는 법에 따라상표권, 특허권을 포함하되이에 국한되지 않는 플랫폼의소유입니다. 권리, 저작권, 영업비밀등</p><p>11.2 본 플랫폼의 서면 동의없이는 누구도 허가 없이 본 웹사이트의 절차나 내용을사용, 수정, 복사, 공개유포, 변경, 배포, 발행또는 공개 게시할 수 없습니다.</p><p>11.3 지적재산권을 존중하는 것은귀하의 의무입니다. 위반한경우에는 손해배상 책임을 져야합니다.</p><p>12. <span style="font-family: 宋体;">법률및</span> <span style="font-family: 宋体;">관할권의적용</span></p><p><span style="font-family: 宋体;">본</span> <span style="font-family: 宋体;">계약의</span> <span style="font-family: 宋体;">유효성</span>, <span style="font-family: 宋体;">해석</span>, <span style="font-family: 宋体;">수정</span>, <span style="font-family: 宋体;">실행</span> <span style="font-family: 宋体;">및</span> <span style="font-family: 宋体;">분쟁해결은</span> <span style="font-family: 宋体;">모두플랫폼이</span> <span style="font-family: 宋体;">위치한지역의</span> <span style="font-family: 宋体;">법률에적용됩니다</span>. <span style="font-family: 宋体;">관련</span> <span style="font-family: 宋体;">법률규정이</span> <span style="font-family: 宋体;">없는경우</span> <span style="font-family: 宋体;">일반적인국제</span> <span style="font-family: 宋体;">비즈니스관행</span> <span style="font-family: 宋体;">및</span>/<span style="font-family: 宋体;">또는</span> <span style="font-family: 宋体;">업계</span> <span style="font-family: 宋体;">관행을참조하십시오</span>. <span style="font-family: 宋体;">본</span> <span style="font-family: 宋体;">계약으로인해</span> <span style="font-family: 宋体;">발생하는분쟁은</span> <span style="font-family: 宋体;">플랫폼이위치한</span> <span style="font-family: 宋体;">곳의법률에</span> <span style="font-family: 宋体;">따라처리되며</span>, <span style="font-family: 宋体;">플랫폼이</span> <span style="font-family: 宋体;">위치한곳의</span> <span style="font-family: 宋体;">사법권을제</span>1<span style="font-family: 宋体;">심</span> <span style="font-family: 宋体;">관할법원으로합니다</span>.</p>`,

  privacyPolicyTitle: '개인 정보 정책',
  privacyPolicy: `<p>본 개인 정보 보호 정책은 FTZINC의모든 관련 서비스에 적용됩니다. FTZINC는 FTZINC 플랫폼서비스를 사용하는 모든 사용자의개인정보를 존중하고 보호합니다. 귀하에게 보다 정확하고개인화된 서비스를 제공하기 위해본 개인정보 보호정책의조항에 따라 귀하의 개인정보를 사용 및공개하지만, FTZINC는이 정보를 높은 수준의 성실함과 신중함으로처리할 것입니다. 본개인정보 보호정책에 달리 규정된경우를 제외하고, FTZINC는귀하의 사전 허가 없이 이 정보를 제3자에게공개하거나 제공하지 않습니다. FTZINC는 수시로 본 개인정보 보호정책을업데이트합니다. 귀하가 FTZINC 서비스 계약에 동의하면 본 개인정보보호정책의 전체 내용에 동의한 것으로 간주됩니다. 본개인정보 보호정책은 서비스 계약의필수적인 부분입니다.</p><p><strong>1. 이용범위</strong></p><p>귀하가 당사 플랫폼에 로그인할 수있는 계정을 등록하거나 활성화하는경우 당사 계열사가 제공하는 다른플랫폼에서 제공하는 귀하의 개인등록 정보(법률및 규정에 따라 공개해야 하는 상호등 관련 사업자 등록 정보는 제외) 및자연인 운영자에 대한 정보 FTZINC 또는 FTZINC 웹페이지를 사용할 때 FTZINC는또한 IP 주소, 브라우저 유형, 사용 언어, 액세스날짜 및 시간, 소프트웨어데이터를 포함하되 이에 국한되지않는 브라우저 및 컴퓨터에대한 정보를 기록합니다. 필요한하드웨어 기능 정보, 웹페이지 기록 등 FTZINC를통해 비즈니스 파트너로부터얻은 사용자의 개인 데이터.</p><p><strong>2. 정보의 이용</strong></p><p>당사는 귀하가 사전에 동의를 얻은 경우 또는 제3자와당사(당사의 계열사포함)가 개별적으로또는 공동으로 귀하에게 서비스를제공하는 경우를 제외하고는 귀하의 개인정보를관련 없는 제3자에게제공, 판매, 임대, 공유또는 거래하지 않습니다. 서비스 종료 후에는 해당 자료에 대한 접근이 모두 금지됩니다.</p><p>전에는 접근이 가능합니다. 또한당사는 제3자가어떤 수단으로든 귀하의 개인정보를수집, 편집, 판매 또는 유포하는 것을 허용하지않습니다. 당사 플랫폼의사용자가 위의 활동에 참여하는 경우, 일단 발견되면 당사는 해당사용자와의 서비스 계약을 즉시 종료할 권리가 있습니다.</p><p><strong>3. 정보공개</strong></p><p>다음과 같은 상황에서 당사는 귀하의개인적 희망이나 법적 규정에따라 귀하의 개인정보 전체 또는일부를 공개합니다. 귀하의사전 동의를 받아 제3자에게공개합니다. 귀하가 자격을갖춘 지적 재산권 불만 제기자이고 불만 사항을제기한 경우 피고인의 요청에 따라양측이 가능한 권리 분쟁을 처리할 수 있도록 피고인에게 공개하십시오. 법률의 관련 규정 또는 행정, 사법기관의 요구에 따라 제3자또는 행정, 사법기관에 공개합니다. 귀하가관련 법률, 규정, 서비스 계약 또는 관련 규칙을 위반하여 제3자에게 공개해야 하는 경우귀하가 요청한 제품 및 서비스를 제공하려면귀하의 개인정보를 제3자와 공유해야 합니다. 당사 플랫폼에서 생성된 거래에서거래 당사자가 거래 의무및 정보 공개 요청을 이행하거나 부분적으로이행하는 경우, 당사는거래 상대방의 연락처 정보와같은 필요한 정보를 사용자에게 제공하기로결정할 권리가 있습니다. 거래완료 또는 분쟁 해결. 우리는법률, 규정 또는웹사이트 정책에 따라 적절하다고 판단되는 정보를공개합니다.</p><p><strong>4. 정보의 저장 및 교환</strong></p><p><span style="font-family: 宋体;">당사가</span> 귀하에대해 수집한 정보와 데이터는 당사 및(또는) 계열사의서버에 저장됩니다. 이정보와 데이터는 당사가 정보와데이터를 수집하고 해외에서 접근할수 있는 귀하의 국가, 지역또는 해외로 전송되어 저장 및표시될 수 있습니다.</p><p><strong>5. 쿠키의 사용</strong></p><p><span style="font-family: 宋体;">귀하가</span> <span style="font-family: 宋体;">쿠키</span> <span style="font-family: 宋体;">허용을거부하지</span> <span style="font-family: 宋体;">않는경우</span> <span style="font-family: 宋体;">당사는귀하가</span> <span style="font-family: 宋体;">로그인하거나쿠키에</span> <span style="font-family: 宋体;">의존하는플랫폼</span> <span style="font-family: 宋体;">서비스또는</span> <span style="font-family: 宋体;">기능을사용할</span> <span style="font-family: 宋体;">수있도록</span> <span style="font-family: 宋体;">귀하의컴퓨터에</span> <span style="font-family: 宋体;">쿠키를설정하거나</span> <span style="font-family: 宋体;">액세스합니다</span>. <span style="font-family: 宋体;">당사는</span> <span style="font-family: 宋体;">귀하에게</span> <span style="font-family: 宋体;">프로모션서비스를</span> <span style="font-family: 宋体;">포함하여보다</span> <span style="font-family: 宋体;">사려깊고</span> <span style="font-family: 宋体;">개인화된서비스를</span> <span style="font-family: 宋体;">제공하기위해</span> <span style="font-family: 宋体;">쿠키를사용합니다</span>. <span style="font-family: 宋体;">귀하는</span> <span style="font-family: 宋体;">쿠키수락</span> <span style="font-family: 宋体;">또는거부를</span> <span style="font-family: 宋体;">선택할권리가</span> <span style="font-family: 宋体;">있습니다</span>. <span style="font-family: 宋体;">귀하는</span> <span style="font-family: 宋体;">브라우저</span> <span style="font-family: 宋体;">설정을수정하여</span> <span style="font-family: 宋体;">쿠키허용을</span> <span style="font-family: 宋体;">거부할수</span> <span style="font-family: 宋体;">있습니다</span>. <span style="font-family: 宋体;">그러나</span> <span style="font-family: 宋体;">귀하가</span> <span style="font-family: 宋体;">쿠키허용을</span> <span style="font-family: 宋体;">거부하는경우</span> <span style="font-family: 宋体;">로그인이불가능하거나</span> <span style="font-family: 宋体;">쿠키에의존하는</span> <span style="font-family: 宋体;">플랫폼서비스나</span> <span style="font-family: 宋体;">기능을이용하지</span> <span style="font-family: 宋体;">못할수도</span> <span style="font-family: 宋体;">있습니다</span>. <span style="font-family: 宋体;">이</span> <span style="font-family: 宋体;">정책은</span> FTZINC<span style="font-family: 宋体;">가</span> <span style="font-family: 宋体;">설정한쿠키를</span> <span style="font-family: 宋体;">통해얻은</span> <span style="font-family: 宋体;">관련정보에</span> <span style="font-family: 宋体;">적용됩니다</span>.</p><p><strong>6. 정보보안</strong></p><p><strong>귀하의 계정에는 보안 보호 기능이 있으므로 계정과 비밀번호 정보를 올바르게 유지하십시오. 당사는 귀하의 정보가 분실, 남용 및 변경되지 않도록 다른 서버에 백업하고 사용자 비밀번호를 암호화하는 등의 보안 조치를 사용할 것입니다. 앞서 언급한 보안 대책에도 불구하고, 정보 네트워크에는 '완벽한 보안 대책'이 없다는 점을 유의하시기 바랍니다. 온라인 거래를 위해 당사의 플랫폼 서비스를 이용하는 경우 귀하는 필연적으로 연락처 정보, 우편 주소 등의 개인정보를 거래상대방 또는 잠재적 거래상대방에게 공개해야 합니다. 귀하의 개인정보를 적절히 보호하시고 필요한 경우에만 타인에게 제공하시기 바랍니다. 귀하의 개인정보, 특히 계정 및 비밀번호가 유출된 것을 발견한 경우, 즉시 당사 고객센터에 연락해 적절한 조치를 취하도록 하십시오. 미성년자를 위한 특별 주의 사항 귀하가 민사상 권리 및 민사 행위 능력을 모두 갖춘 자연인이 아닌 경우, 귀하는 당사의 플랫폼 서비스를 이용할 권리가 없으므로 당사에 어떠한 개인정보도 제공하지 않기를 바랍니다.</strong></p><p><strong>귀하의 계정 서비스가 종료되거나 FTZINC의 계정 권한이 영구적으로 동결(취소)된 후, FTZINC는 귀하의 계정에 있는 정보를 귀하에게 유지하거나 공개할 의무가 없으며 귀하가 읽지 않았거나 귀하에게 읽지 않은 정보를 전달할 의무도 없습니다. 제3자 또는 전송된 메시지.</strong></p><p><strong>귀하는 FTZINC와의 계약 관계가 종료된 후에도 FTZINC가 다음 권리를 계속 누리는 데 동의합니다. FTZINC 서비스를 사용하는 동안 사용자 정보 및 모든 거래 정보를 계속 저장합니다. 귀하가 FTZINC 서비스를 사용하는 동안 법률을 위반하거나 본 계약 및/또는 규칙을 위반하는 경우에도 FTZINC는 본 계약에 따라 귀하의 권리를 주장할 수 있습니다.</strong></p><p><strong>FTZINC가 귀하에 대한 FTZINC 서비스 제공을 중단 또는 종료한 후, 서비스 중단 또는 종료 이전의 귀하의 거래는 다음 원칙에 따라 처리되어야 하며, 귀하는 이를 단독으로 처리하고 모든 분쟁, 손실 또는 추가 비용을 전적으로 부담해야 합니다. 다음 처리로 인해 발생합니다. 또한 FTZINC가 결과적으로 손실이나 비용이 발생하지 않도록 해야 합니다. 비트코인 및 기타 가상 화폐와 같은 가상 화폐 = 서비스 정지 또는 종료 전에 FTZINC에 업로드한 화폐가 아직 거래되지 않은 경우 , FTZINC는 이미 거래를 했을 권리가 있습니다. 다른 회원이 매매 계약을 체결했지만 실제로 해당 계약이 이행되지 않은 경우, FTZINC는 해당 매매 계약 및 비트코인 등 가상화폐 관련 정보를 삭제할 권리가 있습니다. 가상 화폐; 귀하는 서비스가 중단되거나 종료되기 전에 다른 회원과 판매 계약을 체결했으며, 부분적으로 이행된 경우 FTZINC는 거래를 삭제할 수 없지만, FTZINC는 서비스를 중단하거나 종료할 때 관련 상황을 상대방에게 알릴 권리가 있습니다. .</strong></p><p><strong>7. 개인정보 보호정책</strong></p><p><strong>FTZINC는 수시로 FTZINC 사이트에 개인정보 보호정책을 발표하고 개정할 것입니다. 개인 정보 보호 정책은 본 계약의 유효한 부분을 구성합니다.</strong></p>`,

  legalStatementTitle: '법적 진술',
  legalStatement: `<p><strong>제1조:</strong></p><p>본 웹사이트는 미국의 관련 법률 및 규정을 위반하지 않고 최대한 전문적이고 안전하며 신뢰할 수 있는 디지털 자산 거래 및 자산 관리 서비스를 전 세계 디지털 자산 애호가 및 투자자에게 제공하기 위한 것입니다. 그러나 귀하가 거주하는 국가 또는 지역이 디지털 자산 거래가 명시적으로 금지된 관할권이거나 제재 국가 목록에 포함된 관할권인 경우, 귀하는 본 사이트에서 제공하는 서비스 이용을 삼가해야 합니다.</p><p><strong>제2조:</strong></p><p>이 플랫폼은 사용자를 위해 규정을 준수하고 안전하며 신뢰할 수 있는 디지털 자산 거래 환경을 조성하기 위해 최선을 다하고 있습니다. 사용자는 자금 세탁, 밀수, 상업적 뇌물 수수, 악의적인 시장 조작 및 기타 불법 거래 활동이나 불법 활동에 가담하기 위해 본 웹 사이트를 이용하는 것이 금지됩니다. 이를 고려하여 우리는 가능한 한 엄격한 자금 세탁 방지 및 테러 방지 프로그램을 수립하고 효과적인 보안 위험 통제 조치를 취하여 사용자의 합법적인 권리와 이익을 극대화하고 플랫폼의 좋은 평판을 유지합니다.</p><p><strong>제3조:</strong></p><p>관할 당국이 관련 조사 영장을 바탕으로 플랫폼이 특정 사용자를 조사하는 데 협력하도록 요구하거나 해당 계정을 폐쇄 또는 동결하거나 해당 계정에서 자산을 이전하는 등 사용자 계정에 대한 조치를 채택하도록 요구하는 경우 웹사이트는 해당 영장의 유효성과 진위 여부를 확인한 후 관할 기관의 요구 사항에 따라 조사를 지원하기 위해 해당 기관에 사용자 관련 데이터를 제공하거나 해당 작업을 수행해야 합니다. 플랫폼은 사용자의 개인정보 공개로 인해 사용자가 겪을 수 있는 직간접적인 손실이나 조사로 인해 사용자가 자신의 계정을 운영할 수 없는 상황에 대해 어떠한 책임도 지지 않습니다.</p><p><strong>제4조:</strong></p><p>본 웹사이트에서 제공하는 서비스를 이용하는 사용자는 거래에 참여하기 전에 다음 사항을 숙지해야 합니다. 디지털 자산은 정부나 중앙은행의 지원을 받지 않으며, 디지털 자산의 가격은 크게 변동될 수 있으며, 보유 또는 디지털 자산의 사용에는 상당한 위험이 따릅니다. 이를 고려하여, 귀하는 거래 결정을 내리기 전에 합리적이고 신중한 방식으로 자신의 재정 상태를 평가하여 제안된 거래가 귀하에게 적합한지 결정해야 합니다.</p><p><strong>제5조:</strong></p><p>본 웹사이트의 사용자가 본 정책의 조항을 위반하여 세이셸 공화국의 관련 법률을 위반하는 경우, 본 웹사이트는 본 계약에 따른 서비스 제공자로서 플랫폼의 규칙과 서비스를 개선할 의무가 있습니다. 단, 본 웹사이트는 미국의 관련 법률을 위반할 동기가 없으며 해당 법률을 위반한 사실도 없습니다. 따라서 본 웹사이트는 해당 사용자의 행위에 대해 공동 책임을 지지 않습니다.</p><p><strong>제6조:</strong></p><p>어떤 방식으로든 본 웹사이트에 로그인하거나 본 웹사이트의 서비스를 직간접적으로 이용하는 사용자는 본 정책의 내용에 동의하는 것으로 간주되며 본 정책에 자발적으로 동의하는 것으로 간주됩니다.</p><p><strong>제7조:</strong></p><p>본 정책에서 다루지 않은 사항에 대해서는 미국의 관련 법률 및 규정을 참조하시기 바랍니다. 본 선언문이 미국의 관련 법률 및 규정과 충돌하는 경우 후자가 우선합니다.</p>`,

  launderingPolicyTitle: '자금세탁 방지 정책',
  launderingPolicy: `<p>제1조:</p><p>제정의 목적 및 근거 자금세탁 활동은 디지털자산 거래의 발전에 심각한 해를 끼치고, 부패를조장하고 조장하며, 사회분위기를 훼손하고, 이용자의합법적인 권익을 훼손하며, 디지털자산의 기반을 훼손한다는 점을 고려하여, 디지털 자산 거래 플랫폼의 안정적인 운영. 자금세탁 및 테러자금조달 활동을 방지하기 위해 코인브라운은 "코인브라운 자금세탁 방지규정", "고객계약" 및 "거액 거래"에따라 자금세탁 방지 및테러자금 조달 방지법 관련 조항을 이행합니다. ". 본지침은 관리조치 등 회사규정에 따라 작성되었습니다.</p><p>제2조:</p><p>적용 범위 이 지침은 FTZINC 거래플랫폼에서 거래에 참여하는 모든 사용자에게적용됩니다. 사용자는 사용자가위치한 국가 또는 지역의 자금세탁방지 및 테러자금조달방지에 관한 법률 및 규정을 준수해야 하며, 사용자가 거주하는 지역의법률이 규정하는 범위 내에서본 가이드의 조항을 이행해야합니다. 사용자가 위치한국가나 지역의 요구사항이 더 엄격한경우 해당 규정을 따르세요.</p><p>제3조:</p><p>자금세탁방지, 테러자금조달방지는 마약범죄, 지하계성격의 조직범죄, 테러범죄, 밀수범죄, 부패및 뇌물범죄, 금융사기범죄 및 사보타주 금융관리 명령범죄 및 기타 불법 소득, 자금세탁활동의 출처와 성격, 관련법률 및 코인브라운 자금세탁방지규정에따라 관련 조치를 취하도록 명령합니다.</p><p>제4조:</p><p>코인브라운 자금세탁방지관련규정 코인브라운의 자금세탁방지(테러자금조달방지 포함, 이하 동일) 관련규정에는 "이용약관"의자금세탁방지 부분인 "코인브라운자금세탁방지 규정"이포함됩니다. , 그리고 "대규모 거래 관리 대책"이가이드와 함께 제공됩니다. 본가이드에 명시된 내용이 다른 규정과 상충되는 경우에는 본가이드가 우선적으로 적용됩니다.</p><p>제5조:</p><p>코인브라운의 자금세탁방지기본 원칙은 다음 원칙에 따라 고객 위험 모니터링 업무를 수행하는것입니다.</p><p>포괄성의 원칙. 코인브라운 플랫폼은 고객이자금세탁에 연루될 수 있는 다양한 위험 요소를 종합적으로 고려하고 합리적인방법을 채택하여 모든 고객의위험을 모니터링합니다.</p><p>신중함의 원칙. 코인브라운 플랫폼은 고객에대한 완전한 이해를 바탕으로 고객 식별능력을 향상시키고, 고객리스크를 신중하게 모니터링할것입니다.</p><p>지속 가능성의 원칙. 코인브라운 플랫폼은 앞으로도고객의 리스크에 주의를 기울이고실제 상황에 따라 적절하게 대응할 것입니다.</p><p>기밀 유지의 원칙. FTZINC 플랫폼이보유하고 있는 고객 신원 정보, 거래정보 및 위험 수준 정보는 엄격하게 기밀이며 법적규정 및 규제 요구 사항에 부합하지 않는 한어떤 단위나 개인에게도 제공되지 않습니다.</p><p>계층적 관리의 원칙. 코인브라운플랫폼은 고객의 위험도에 따라 저장된고객 기본정보를 정기적으로검토합니다. 위험 수준이높은 고객에 대한 검토는 위험 수준이 낮은 고객에 대한 검토보다 엄격해야 합니다.</p><p>제6조:</p><p>개인 사용자 문서 제출 코인브라운의 개인 사용자는코인브라운 자금세탁방지 규정에 따라다음 정보와 자료를 제출해야 합니다.</p><p>개인 이름</p><p>신분증, 여권, 운전면허증 등 유효한서류</p><p>코인브라운의 요청 시제공되어야 하는 기타 정보 또는 문서.</p><p>제7조:</p><p>기관 사용자 문서 제출 코인브라운 기관 사용자는코인브라운 자금세탁 방지 규정에따라 다음 정보와 자료를 제출해야 합니다.</p><p>회사 이름;</p><p>회사 등록 사무실 주소</p><p>회사의 법정대리인</p><p>회사의 법정대리인의 주소</p><p><span style="font-family: 宋体;">사업</span> 허가증;</p><p><span style="font-family: 宋体;">회사의</span> <span style="font-family: 宋体;">법정대리인의</span> <span style="font-family: 宋体;">신분증또는</span> <span style="font-family: 宋体;">여권사본</span></p><p><span style="font-family: 宋体;">코인브라운의</span> <span style="font-family: 宋体;">요청</span> <span style="font-family: 宋体;">시제공되어야</span> <span style="font-family: 宋体;">하는기타</span> <span style="font-family: 宋体;">정보또는</span> <span style="font-family: 宋体;">문서</span>.</p><p>제8조:</p><p>사용자 문서 검토. 코인브라운플랫폼은 코인브라운 자금세탁방지규정의고객 식별 시스템에 따라 고객이제출한 관련 정보를 확인하고 기록합니다. 플랫폼은 고객이 제출한정보에 대해 질문이 있는 경우 관련 관할 기관이나 부서에 확인을요청할 권리가 있습니다.</p><p>제9조:</p><p>저위험 사용자 모니터링 FTZINC 플랫폼은 FTZINC 자금 세탁 방지 규정의 특정 요구 사항에 따라 저위험 사용자를 감지합니다. FTZINC 플랫폼은 저위험 사용자의수준을 조정할 권리를 보유합니다.</p><p>제10조:</p><p>고위험 사용자 모니터링 FTZINC 플랫폼은 6개월마다 고위험 고객을검토하여 고객 신원에 대한 기본 정보를 업데이트하고 자금 출처, 자금 사용, 경제상황 또는 운영 조건에 대해 학습합니다.</p><p>제11조:</p><p>사용자 파일의 보존 코인브라운 플랫폼은 고객신원정보 및 거래정보를 일정 기간동안 보관하기 위해 법률에따라 필요한 조치를 취합니다. 국제적으로통용되는 규정에 의거, 이용자신원정보는 거래관계 종료 후최소 5년간, 고객거래정보는 거래 종료후 최소 5년간보관해야 합니다.</p><p>제12조:</p><p>사용자 주의 코인브라운 사용자는 다음사항에 주의해야 합니다. 사용자 자신의 계정을 타인에게 빌려주는 것은금지되어 있습니다.</p><p>사용자의 신분증을 대여하거나대여하는 것은 금지되어 있습니다.</p><p>이용자 자신의 계좌, 은행카드, 통장, 비밀번호및 기타 중요한 개인 재산 정보를 임대, 대여또는 공개하는 것은 금지되어있습니다.</p><p>사용자는 고객 식별을위해 FTZINC 플랫폼에적극적으로 협조해야 합니다.</p><p>FTZINC 플랫폼에서거래할 때 결제 활동을 위해 안전하고 신뢰할 수있는 제3자금융 기관을 선택하고 이용하세요.</p><p>제13조:</p><p>의심스러운 행동 신고 FTZINC 플랫폼 사용자가 플랫폼 거래중에 어떤 계정이 돈세탁이나 테러 자금조달 활동에 연루되었을 수 있음을발견한 경우 사용자는 FTZINC 플랫폼에신고할 수 있습니다.</p><p>제14조:</p><p><span style="font-family: 宋体;">본</span> 가이드의가이드라인 해석은 FTZINC 플랫폼에의해 해석됩니다.</p><p><span style="font-family: 宋体;">제</span>15<span style="font-family: 宋体;">조</span>:</p><p><span style="font-family: 宋体;">유효기간</span> <span style="font-family: 宋体;">본</span> <span style="font-family: 宋体;">가이드라인은발행일로부터</span> <span style="font-family: 宋体;">시행됩니다</span>.</p>`,
  
  tradeMin100: '최소 거래 금액: 100 USDT',
  cancelled: '취소 된',

  phone: '전화(선택)',
  phone1: '전화',

  start1: '가입하기',

  toTrade: '지금 거래하세요',

  openRecord: '기록 열기',
  closeRecord: "기록 닫기",

  closeOrder: '주문 마감',


  swiperTitle2: '암호화폐를 구매, 판매, 거래, 보유 및 획득할 수 있는 올인원 암호화폐 플랫폼입니다.',
  swiperSub2: '우리는 수백만 명의 글로벌 사용자의 디지털 자산 여정을 안내해 왔습니다.',

  homeremind31: '암호화폐 구매',
  homeremind32: '당신은 지불',
  homeremind33: '당신은 얻을',
  homeremind34: '가격은 다음 날짜에 다시 계산됩니다.',
  homeremind35: '이용약관',
  homeremind36: '지금 구매',
  homeremind37: 'FTZINC는 모두를 위한 One-step 플랫폼입니다.',
  homeremind38: '클라이언트',
  homeremind39: '지원되는 국가',
  homeremind40: '분기별 거래량',

  homeremind41: '시작하는 방법',
  homeremind42: '계정 만들기',
  homeremind43: '새 프로필을 등록하려면 FTZINC에 로그인하세요.',
  homeremind44: '신원 확인',
  homeremind45: '확인 프로세스를 완료하는 데 5분 미만이 소요됩니다.',
  homeremind46: '먼저 계정을 만드세요',
  homeremind47: '암호화폐 구매 및 입금',
  homeremind48: '암호화폐 서비스에 액세스하려면 FTZINC 계정에 자금을 추가하세요.',
  homeremind49: '먼저 신원을 확인하세요',
  homeremind50: '여행을 시작하세요',


  homeremind51: 'FTZINC 생태계 내에서 암호화폐 기회를 탐색해 보세요.',
  homeremind52: '암호화폐를 먼저 구매하고 입금하세요',
  homeremind53: '암호화폐 포트폴리오 구축',
  homeremind54: '암호화폐 구매',
  homeremind55: '왜 FTZINC인가?',
  homeremind56: '간단',
  homeremind57: 'FTZINC를 사용하면 모바일 애플리케이션을 사용하여 암호화폐를 쉽게 구매할 수 있습니다.',
  homeremind58: '교육',
  homeremind59: '어디서부터 시작해야 할지 모르시나요? 학습 센터로 가서 암호화폐의 모든 것에 대해 알아보세요.',

  homeremind60: '서비스',
  homeremind61: '지원 센터에서 즉시 답변을 찾아보세요. 또는 이메일을 통해 연중무휴 24시간 연락해 주세요.',
  homeremind62: 'FTZINC 시작하기',

  selectText: '찾다', 



  ieointro1: `창립 팀`,
  ieointro2: `엔젤 펀드`,
  ieointro3: `생태계`,
  ieointro4: `사전 판매 단계`,
  ieointro5: `채굴`,


  ieointro10: `창립 팀`,
  ieointro11: `엔젤 펀드`,
  ieointro12: `생태계`,
  ieointro13: `사전 판매 할당`,
  ieointro14: `채굴 보상`,



  tradename: '거래',


  swiperTitle3: '차세대 찾기',
  swiperTitle4: 'FTZINC의 암호화폐 거래',
  swiperTitle5: `암호화폐 거래소 {'|'} 마진거래 {'|'} 암호화폐 파생상품`,

  homeremind64: '지금 등록하세요',
  homeremind65: '해당 국가',
  homeremind66: '글로벌 투자자',
  homeremind67: '암호화폐',
  homeremind68: '24시간 거래량',

  homeremind69: 'Scan QR Code to Download App',//No need
  homeremind70: '이메일 주소',

  homeremind71: '새로운 암호화폐 사전 판매',
  homeremind72: 'View all 700+ coins', //No need

  homeremind73: 'Coming Soon',//No need
  homeremind74: '구독하다',

  homeremind75: '핫리스트',
  homeremind76: '승자 목록',
  homeremind77: '패자 목록',

  homeremind78: '지금 세계 최고의 암호화폐 거래소를 경험해보세요',
  homeremind79: `안전 {'|'} 수수료 없음 {'|'} 빠른 {'|'} 분산`,
  homeremind80: 'View more benefits',//No need
  homeremind81: '이메일 주소로 가입하고 지금 바로 거래하려면 단 한 단계만 거치면 됩니다.',


  homeremind82: 'FTZINC 제품 및 서비스 살펴보기',
  homeremind83: '현물 거래',
  homeremind84: '귀하의 이익을 극대화하기 위해 포괄적이고 강력한 도구 세트로 암호화폐를 거래하세요.',
  homeremind85: '암호화폐 구매',
  homeremind86: '인기 있고 업계를 선도하는 플랫폼에서 빠르고 쉽게 암호화폐를 구매하세요.',
  homeremind87: '암호화폐 파생상품',
  homeremind88: '우리는 암호화폐 선물 거래를 위한 최고의 암호화폐 거래소입니다.',
  homeremind89: 'FTZINC Earn',//No need
  homeremind90: 'Invest and earn steady income with the help of a professional asset manager.',//No need
  homeremind91: 'Trading Bot',//No need
  homeremind92: 'Earn passive income round-the-clock without having to constantly monitor markets.',//No need
  homeremind93: '마진거래',
  homeremind94: '마진 거래로 자산을 활용하세요.',
  homeremind95: 'Leveraged Tokens',//No need
  homeremind96: 'Amplify your investment returns by simply buying and selling leveraged tokens.',//No need
  homeremind97: 'Halo Wallet',//No need
  homeremind98: 'A self-custody social wallet that allows you to easily discover, invest, and earn.',//No need

  homeremind99: '안전하고 신뢰할 수 있는 암호화폐 거래소',
  homeremind100: '안전한 자산 보관',
  homeremind101: '업계 최고의 암호화 및 저장 시스템은 귀하의 자산을 항상 안전하게 보호합니다.',
  homeremind102: '강력한 계정 보안',
  homeremind103: '우리는 귀하의 계정을 안전하게 유지하기 위해 가장 높은 보안 표준을 준수하고 가장 엄격한 보안 관행을 구현합니다.',
  homeremind104: '신뢰할 수 있는 플랫폼',
  homeremind105: '우리는 모든 사이버 공격에 대한 신속한 탐지 및 대응을 보장하기 위해 보안 기반 설계 기반을 갖추고 있습니다.',
  homeremind106: 'PoR — 자산 투명성',
  homeremind107: 'PoR(예비금 증명)은 블록체인 자산의 보관을 증명하는 데 널리 사용되는 방법으로, FTZINC가 장부에 있는 모든 사용자 자산을 포괄하는 자금을 보유하고 있음을 확인합니다.',

  homeremind108: 'Learn More',//No need
  homeremind109: '언제 어디서나 거래하세요',
  homeremind110: 'FTZINC 앱과 웹사이트를 사용하면 암호화폐를 쉽게 거래할 수 있습니다.',
  
  
  homeremind111: '연중무휴 고객 서비스',
  homeremind112: '귀하의 질문에 대한 답변. 질문이 있으면 언제든지 FTZINC 고객 지원팀에 문의하세요.',
  homeremind113: 'FTZINC Help Center',//No need
  homeremind114: '우리 커뮤니티에 가입하세요',
  homeremind115: 'FTZINC 글로벌 커뮤니티는 100개 이상의 국가에서 수백만 명의 사용자가 거주하며 20개 이상의 언어를 지원합니다.',
  homeremind116: '영어 커뮤니티',
  homeremind117: 'View all 20+ languages',//No need
  homeremind118: '당신의 옆에 있는 FTZINC',
  homeremind119: '지금 암호화폐 여행을 시작하세요!',
  
  appDownload: '앱 다운로드',
  androidDownload: '안드로이드 다운로드',
  iosDownload: 'iOS 다운로드',


  funding: '자금 조달',


  successText: '성공', 

  withdrawTip4: `출금 신청 시마다`,
  withdrawTip5: `의 서비스 수수료가 공제되고, 출금 금액에 대해서도`, 
  withdrawTip6: `만 공제됩니다.`, 


  homeremind212: '자산 개요',
  homeremind213: '입금',
  homeremind214: '현물 시장',
  homeremind215: '거래',
  homeremind216: '사전 판매',
  homeremind217: '가입하는 데 30초만 걸립니다',
  homeremind218: '글로벌 디지털 통화',
  homeremind219: '지금 거래하세요',
  homeremind220: 'DAS 프리세일 진행 중',
  homeremind221: '가장 인기 있는 IEO',
  homeremind222: '구독하기',
  homeremind223: '마진 거래 시작',
  homeremind224: '최대 200배 레버리지',


  emailCheck: '이메일 확인 코드', 


  ieoIntro: '토큰 소개',
  homeSentence1: `7*24 서비스`,
  homeSentence2: `정규직 운영`,
  homeSentence3: `모든 거래 요구 사항을 충족하기 위해`,
  homeSentence4: `언제 어디서나 거래 가능`,


  lastStep: `이전의`,


  commodities: '상품',




  forgotPassword: `비밀번호를 잊으셨나요?`,
  registerText: `계정이 없으신가요?`,
  registerText1: `여기에서 가입하세요`,

  loginText: `계정에 로그인하세요`,
  loginText1: `계정이 있으신가요?`,
  loginText2: `여기에서 로그인하세요`,

  loginPolicy: `가입함으로써 본인은 서비스 약관 및 개인정보처리방침에 명시된 개인정보 처리방침에 동의합니다.`,
  registerPolicy: `로그인함으로써 본인은 서비스 약관 및 개인정보처리방침에 명시된 개인정보 처리방침에 동의합니다.`,

  loginLayoutText: `전 세계 150만 명 이상의 사용자가 신뢰하는 서비스입니다. 언제든 준비되셨을 때 함께합니다.`,

  homeSwiperTitle: `최고의 암호화폐 거래 플랫폼에서 현물, 마진, 선물 및 장외 거래를 하세요.`,
  homeSwiperText: `프로 트레이딩, 누구나 쉽게.`,

  startTrading: '거래 시작하기',
  exploreMarkets: '시장 탐색',

  downloadOn: `다운로드`,
  getItOn: `시작하세요`,

  homeCoinListSentence: `초보자와 전문 트레이더 모두를 위한 정보`,
  homeCoinListSentence1: `구매, 판매 및 관리`,
  homeCoinListSentence2: `100개 이상의 암호화폐 자산`,
  homeCoinListSentence3: `모든 암호화 자산을 살펴보세요`,

  homeWhyChooseSentence: `FTZINC을 선택하는 이유는 무엇일까요?`,
  homeWhyChooseSentence1: `전 세계 150만 명 이상의 사용자가 선택한 암호화폐 거래소`,
  //homeWhyChooseSentence2: `more than 1.5 million users globally`,
  homeWhyChooseSentence3: `효율적인 시장`,
  homeWhyChooseSentence4: `FTZINC의 유동성이 높은 현물, 현물 마진, 무기한 선물 시장에서 100가지 이상의 암호화폐 자산을 거래하고, 다양한 주문 유형과 거래 도구를 활용해 보세요.`,
  homeWhyChooseSentence5: `유연한 수율 제품`,
  homeWhyChooseSentence6: `저희의 간편한 유동성 스테이킹 솔루션으로 수익을 창출하세요. 복잡한 온라인 스테이킹 과정은 저희가 모두 처리해 드립니다.`,
  homeWhyChooseSentence7: `세계 최고 수준의 API`,
  homeWhyChooseSentence8: `당사의 기관급 API는 실시간 및 과거 시장 데이터, 공유 계정, 그리고 매우 경쟁력 있는 요금 한도를 제공합니다.`,
  homeWhyChooseSentence9: `간편한 환율 변환`,
  homeWhyChooseSentence10: `간편한 구매 및 판매 스왑 터미널, 은행 송금 또는 OTC 플랫폼을 통해 다양한 통화를 암호화폐로 손쉽게 변환하세요.`,
  homeWhyChooseSentence11: `고객 지원`,
  homeWhyChooseSentence12: `저희는 고객의 요구에 맞춰 서비스를 제공하며, 신속하고 유용한 고객 지원과 기업 파트너를 위한 전용 지원 채널을 제공합니다.`,
  homeWhyChooseSentence13: `빠른 온보딩`,
  homeWhyChooseSentence14: `KYC 및 AML 규정을 완벽하게 준수하고 데이터 개인정보 보호를 최우선으로 고려한 당사의 자동화된 온보딩 프로세스는 몇 분 안에 완료될 수 있습니다.`,

  homeQuicklyStartSentence: `빠르게 거래를 시작하세요`,
  homeQuicklyStartSentence1: `몇 분 안에 시작하세요`,
  //homeQuicklyStartSentence2: `in minutes`,
  homeQuicklyStartSentence3: `계좌 개설`,
  homeQuicklyStartSentence4: `몇 분 만에 계정을 만들고 인증하세요`,
  homeQuicklyStartSentence5: `계정에 자금을 입금하세요`,
  homeQuicklyStartSentence6: `은행 송금을 통해 법정화폐를 입금하거나 암호화폐를 직접 입금하여 계정에 자금을 충전하세요.`,
  homeQuicklyStartSentence7: `거래를 시작하세요`,
  homeQuicklyStartSentence8: `100가지 이상의 암호화폐 자산을 현물, 현물 마진, 선물 거래로 거래하거나, 강력한 API를 연동하여 거래 수익을 극대화하세요.`,

  homeGetStartSentence: `프로 트레이딩,`,
  homeGetStartSentence1: `모두를 위해.`,
  homeGetStartSentence2: `시작하기`,

  homeOurInvestorsSentence: `우리 투자자들`,


  favorites: '즐겨찾기',
  original: '원래의',



  indices: `지수`,
  indicesNotAllowOpen: `시장 폐장 중에는 포지션을 열 수 없습니다.`,
  indicesNotAllowClose: `시장 폐장 중에는 포지션을 청산할 수 없습니다.`,
  indicesNotAllowSet: `시장 폐장 중에는 주문을 수정할 수 없습니다.`,
  


  tokenIntroduction: `토큰 소개`,
  newWhitepaper: `백서`,


  kbfIntro1: `싱가포르에 본사를 둔 Quantum Asset Management Pte Ltd가 주도하는 Kentucky Butterfly Farm(KBF)은 자산 거래를 위한 선구적인 AMM 기반 퍼블릭 블록체인입니다. 글로벌 회계 시장 조성자(AMM) 메커니즘, 블록체인 게임 및 소셜 인프라를 기반으로 구축된 KBF는 상업용 애플리케이션을 위한 슈퍼컴퓨팅 시스템 역할을 하며, AMM, GameFi, SocialFi를 포함한 다양한 서비스의 신속한 배포를 가능하게 합니다.`,

kbfIntro2: `KBF 퍼블릭 블록체인 네트워크 기술은 여러 가지 장점을 보여줍니다. 가장 큰 특징은 고성능으로, 더 많은 거래를 처리하고 거래 확인 시간을 단축할 수 있다는 점입니다. 디지털 금융 분야에서 속도와 효율성은 서비스 품질을 평가하는 핵심 지표입니다. KBF 블록체인은 기술 아키텍처를 지속적으로 최적화하여 거래 처리 능력을 향상시키고 사용자에게 더욱 빠르고 효율적인 금융 서비스 경험을 제공합니다.`,

kbfIntro3: `둘째, KBF 퍼블릭 블록체인은 탁월한 확장성을 자랑합니다. 디지털 금융 시장의 급속한 성장과 함께 사용자 기반과 애플리케이션 수요가 지속적으로 증가하고 있습니다. 이러한 증가하는 수요를 충족하기 위해 KBF 블록체인은 처음부터 미래의 네트워크 확장성을 고려하여 설계되었습니다. AMM(자동 시장 조성) 및 영지식 증명 기술을 활용하여 사용자 트래픽 및 거래량의 급증을 원활하게 처리하고 안정적인 네트워크 운영과 지속 가능한 발전을 보장합니다.`,



}
